webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REMOTE_PATHS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var getRemotePaths = function getRemotePaths() {
  var defaults = {
    development: {
      KCHAT_API_PATH: 'https://kc-connect.appunite.net/api',
      KCONF_API_PATH: 'https://kingsconference.appunite.com',
      WS_PATH: 'wss://kingsconference.appunite.com',
      AUTH_PATH: 'http://localhost:5050',
      OAUTH_CLIENT_ID: 'com.newmedia.conference.debug',
      COOKIE_DOMAIN: 'localhost'
    },

    testing: {
      KCHAT_API_PATH: 'https://kc-connect.appunite.net/api',
      KCONF_API_PATH: 'https://kingsconference.appunite.com',
      WS_PATH: 'wss://kingsconference.appunite.com',
      AUTH_PATH: 'https://accounts.staging.kingsch.at',
      OAUTH_CLIENT_ID: 'com.newmedia.conference.debug',
      COOKIE_DOMAIN: '.staging.kingsch.at'
    },

    production: {
      KCHAT_API_PATH: 'https://connect.kingsch.at/api',
      KCONF_API_PATH: 'https://conference.kingsch.at',
      WS_PATH: 'wss://conference.kingsch.at',
      AUTH_PATH: 'http://localhost:5050',
      OAUTH_CLIENT_ID: 'com.newmedia.conference',
      COOKIE_DOMAIN: '.kingsch.at'
    }
  };

  var ENV = window.ENV !== '$ENV' ? JSON.parse(window.ENV) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaults["production"]);

  var constructAuthPath = function constructAuthPath() {
    var accounts = ENV.AUTH_PATH;
    var auth_path = accounts + '?client_id=' + ENV.OAUTH_CLIENT_ID;
    auth_path = auth_path + '&scopes=["conference_calls"]';
    auth_path = auth_path + '&redirect_uri=' + window.location.protocol + '//' + window.location.host;
    return auth_path;
  };

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, ENV, {
    AUTH_PATH: constructAuthPath(),
    IDS_WITH_ACCESS_TO_HIDDEN_FEATURES: ['58a5a947394f717ff2842725', // milosz
    '538cef4a73312e1109540000', // karol
    '538d076b73322e7e30110400', // thisgokeboysef
    '598831cb6ca2ea3d29ebfaa0', // viktorgunko,
    '539218ed73322e447a470000' // pastorrita
    ]
  });
};

var REMOTE_PATHS = getRemotePaths();

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_remote_paths_constant__ = __webpack_require__(12);




var getHeaders = function getHeaders() {
  return {
    Accept: 'application/x-protobuf',
    Authorization: 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$cookie.get('accessToken')
  };
};

var postHeaders = function postHeaders() {
  var token = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$cookie.get('accessToken');
  var headers = {
    Accept: 'application/x-protobuf',
    'Content-Type': 'application/x-protobuf'
  };
  if (token) {
    headers.Authorization = 'Bearer ' + token;
  }
  return headers;
};

var constructPath = function constructPath(path, base) {
  var prefix = void 0;
  if (base) {
    prefix = base;
  } else {
    prefix = __WEBPACK_IMPORTED_MODULE_2__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].KCONF_API_PATH;
  }
  return '' + prefix + path;
};

var api = {
  _get: function _get(_ref) {
    var path = _ref.path,
        params = _ref.params,
        base = _ref.base;

    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(constructPath(path, base), {
      headers: getHeaders(),
      params: params,
      responseType: 'arraybuffer'
    });
  },
  _post: function _post(_ref2) {
    var path = _ref2.path,
        body = _ref2.body,
        base = _ref2.base;

    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(constructPath(path, base), body, {
      headers: postHeaders(),
      responseType: 'arraybuffer'
    });
  },
  _put: function _put(_ref3) {
    var path = _ref3.path,
        body = _ref3.body,
        base = _ref3.base;

    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.put(constructPath(path, base), body, {
      headers: postHeaders(),
      responseType: 'arraybuffer'
    });
  },
  _patch: function _patch(_ref4) {
    var path = _ref4.path,
        body = _ref4.body,
        base = _ref4.base;

    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.patch(constructPath(path, base), body, {
      headers: postHeaders(),
      responseType: 'arraybuffer'
    });
  },
  login: function login(body) {
    return this._post({
      base: __WEBPACK_IMPORTED_MODULE_2__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].KCHAT_API_PATH,
      path: '/authentication/log_in',
      body: body
    });
  },
  getCurrentUser: function getCurrentUser() {
    return this._get({
      path: '/user'
    });
  },
  createSlot: function createSlot(body) {
    return this._post({
      path: '/conference/create_slot',
      body: body
    });
  },
  muteCall: function muteCall(body, slot_id) {
    return this._put({
      path: '/conference/' + slot_id + '/mute',
      body: body
    });
  },
  muteAll: function muteAll(slot_id) {
    return this._put({
      path: '/conference/' + slot_id + '/mute_all'
    });
  },
  lockCall: function lockCall(body, slot_id) {
    return this._put({
      path: '/conference/' + slot_id + '/lock',
      body: body
    });
  },
  setTitle: function setTitle(body, slot_id) {
    return this._put({
      path: '/conference/' + slot_id + '/title',
      body: body
    });
  },
  endCall: function endCall() {
    return this._put({
      path: '/conference/end_conference'
    });
  },
  leaveCall: function leaveCall(slot_id, body) {
    return this._put({
      path: '/conference/' + slot_id + '/end',
      body: body
    });
  },
  getGeo: function getGeo() {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('https://freegeoip.net/json/');
  },
  setUsername: function setUsername(body) {
    return this._put({
      path: '/user/username',
      body: body
    });
  },
  setUserPin: function setUserPin(body) {
    return this._put({
      path: '/user/pin',
      body: body
    });
  },
  getHistory: function getHistory(params) {
    return this._get({
      path: '/conference/history',
      params: params
    });
  },
  muteUser: function muteUser(body, slot_id) {
    return this._put({
      path: '/conference/' + slot_id + '/mute_user',
      body: body
    });
  },
  unmuteUser: function unmuteUser(body, slot_id) {
    return this._put({
      path: '/conference/' + slot_id + '/unmute_user',
      body: body
    });
  },
  kickUser: function kickUser(body, slot_id) {
    return this._post({
      path: '/conference/' + slot_id + '/kick',
      body: body
    });
  },
  putAdminRights: function putAdminRights(body, slot_id, user_id) {
    return this._put({
      path: '/conference/' + slot_id + '/admin/' + user_id,
      body: body
    });
  },
  sendChatMessage: function sendChatMessage(body, chatChannelName) {
    return this._put({
      path: '/conference/' + chatChannelName + '/chat',
      body: body
    });
  },
  getChatMessages: function getChatMessages(chatChannelName, params) {
    return this._get({
      path: '/conference/' + chatChannelName + '/chat',
      params: params
    });
  },
  uploadImage: function uploadImage(file, onprogress) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var formData = new FormData();
      formData.append('image', file);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.imgur.com/3/upload');
      xhr.onloadend = function (e) {
        resolve(e.target.response);
      };
      xhr.upload.onprogress = onprogress;
      xhr.send(formData);
    });
  },
  getContacts: function getContacts() {
    return this._post({
      base: __WEBPACK_IMPORTED_MODULE_2__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].KCHAT_API_PATH,
      path: '/contacts'
    });
  },
  inviteUser: function inviteUser(id, body) {
    return this._post({
      base: __WEBPACK_IMPORTED_MODULE_2__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].KCHAT_API_PATH,
      path: '/users/' + id + '/new_message',
      body: body
    });
  },
  getUserInfo: function getUserInfo(user_id) {
    return this._get({
      base: __WEBPACK_IMPORTED_MODULE_2__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].KCHAT_API_PATH,
      path: '/users/' + user_id
    });
  },
  checkUserSubscription: function checkUserSubscription() {
    return this._get({
      path: '/conference/buy'
    });
  },
  startBroadcast: function startBroadcast(body) {
    return this._post({
      path: '/broadcast/start_broadcast',
      body: body
    });
  },
  stopBroadcast: function stopBroadcast() {
    return this._post({
      path: '/broadcast/end_broadcast'
    });
  },
  checkBroadcastingStatus: function checkBroadcastingStatus() {
    return this._get({
      path: '/broadcast/status'
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_menu_main_menu__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_main_menu_main_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_main_menu_main_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_menu_home_tab_home_tab__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_menu_home_tab_home_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_main_menu_home_tab_home_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_menu_history_tab_history_tab__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_main_menu_history_tab_history_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_main_menu_history_tab_history_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_menu_settings_tab_settings_tab__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_main_menu_settings_tab_settings_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_main_menu_settings_tab_settings_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_main_menu_broadcasting_tab_broadcasting_tab__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_main_menu_broadcasting_tab_broadcasting_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_main_menu_broadcasting_tab_broadcasting_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_room_room__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_room_room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_room_room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_remote_paths_constant__ = __webpack_require__(12);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  root: '/',
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home-tab',
    meta: { auth: true, redirect: 'MainMenu' }
  }, {
    path: '/:username',
    component: __WEBPACK_IMPORTED_MODULE_2__components_main_menu_main_menu___default.a,
    meta: { auth: true },
    children: [{
      path: '',
      name: 'MainMenu',
      component: __WEBPACK_IMPORTED_MODULE_3__components_main_menu_home_tab_home_tab___default.a
    }, {
      path: '/history',
      name: 'HistoryTab',
      component: __WEBPACK_IMPORTED_MODULE_4__components_main_menu_history_tab_history_tab___default.a
    }, {
      path: '/settings',
      name: 'SettingsTab',
      component: __WEBPACK_IMPORTED_MODULE_5__components_main_menu_settings_tab_settings_tab___default.a
    }, {
      path: '/broadcast',
      name: 'BroadcastingTab',
      component: __WEBPACK_IMPORTED_MODULE_6__components_main_menu_broadcasting_tab_broadcasting_tab___default.a
    }]
  }, {
    path: '/c/:username/:pin',
    name: 'Room',
    component: __WEBPACK_IMPORTED_MODULE_7__components_room_room___default.a,
    meta: { auth: true }
  }, { path: '*', redirect: '/' }]
});

router.beforeEach(function (to, from, next) {
  var authRequired = to.matched.some(function (route) {
    return route.meta.auth;
  });
  var authed = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$cookie.get('accessToken');
  if (to.meta.redirect === 'MainMenu' && authed) {
    var user = JSON.parse(localStorage.getItem('currentUser'));
    if (user && user.username) {
      next({
        name: 'MainMenu',
        params: { username: user.username }
      });
    }
  }
  if (authRequired && !authed) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$cookie.delete('accessToken');
    window.location.href = '' + __WEBPACK_IMPORTED_MODULE_8__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].AUTH_PATH + window.location.pathname;
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(439),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a615e25",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/


var $protobuf = __webpack_require__(373);

var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.setOptions({
  objc_class_prefix: "KingsConference_"
})
.addJSON({
  conversations: {
    options: {
      java_package: "com.appunite.chat.model.conversations",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true
    },
    nested: {
      CreateConversationServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 2
          },
          metadata: {
            rule: "required",
            type: "ConversationMetadata",
            id: 3
          }
        }
      },
      UpdateConversationServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          groupMetadata: {
            rule: "required",
            type: "GroupConversationMetadata",
            id: 2
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          }
        }
      },
      DeleteConversationServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          }
        }
      },
      CreateConversationClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          metadata: {
            rule: "required",
            type: "ConversationMetadata",
            id: 2
          }
        }
      },
      CreateConversationConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          }
        }
      },
      UpdateConversationClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          groupMetadata: {
            rule: "required",
            type: "GroupConversationMetadata",
            id: 4
          }
        }
      },
      UpdateConversationConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          }
        }
      },
      DeleteConversationClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          isGroup: {
            rule: "required",
            type: "bool",
            id: 3
          }
        }
      },
      DeleteConversationConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          }
        }
      },
      ConversationMetadata: {
        oneofs: {
          type: {
            oneof: [
              "groupMetadata",
              "singleMetadata"
            ]
          }
        },
        fields: {
          groupMetadata: {
            type: "GroupConversationMetadata",
            id: 1
          },
          singleMetadata: {
            type: "SingleConversationMetadata",
            id: 2
          }
        }
      },
      GroupConversationMetadata: {
        fields: {
          participantsIds: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          avatar: {
            type: "string",
            id: 2
          },
          name: {
            rule: "required",
            type: "string",
            id: 3
          },
          creatorId: {
            rule: "required",
            type: "string",
            id: 4
          },
          adminIds: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          externalMetadata: {
            type: "bytes",
            id: 6
          }
        }
      },
      SingleConversationMetadata: {
        fields: {
          participantsIds: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      }
    }
  },
  messages: {
    options: {
      java_package: "com.appunite.chat.model.messages",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true
    },
    nested: {
      CreateMessageServerMessage: {
        fields: {
          messageId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          actorId: {
            rule: "required",
            type: "string",
            id: 3
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 4
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 5
          },
          likedUserIds: {
            rule: "repeated",
            type: "string",
            id: 6
          }
        }
      },
      UpdateMessageServerMessage: {
        fields: {
          messageId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          actorId: {
            rule: "required",
            type: "string",
            id: 3
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 4
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 5
          },
          likedUserIds: {
            rule: "repeated",
            type: "string",
            id: 6
          }
        }
      },
      DeleteMessageServerMessage: {
        fields: {
          messageId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          }
        }
      },
      CreateMessageClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 3
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 4
          }
        }
      },
      CreateMessageConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          }
        }
      },
      CreateMessageNeedToBeDeletedConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          }
        }
      },
      DeleteMessageClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 3
          },
          retract: {
            rule: "required",
            type: "bool",
            id: 4
          }
        }
      },
      DeleteMessageConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          developerInfoMessageDeletionWasFaked: {
            type: "bool",
            id: 3
          }
        }
      },
      UpdateMessageClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 3
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 4
          }
        }
      },
      UpdateMessageConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          }
        }
      },
      BodyTypes: {
        oneofs: {
          body: {
            oneof: [
              "text",
              "blobText",
              "ping",
              "image",
              "location",
              "attachment",
              "contact",
              "timelineForward",
              "groupEvent",
              "superuserProfile",
              "superuserPost",
              "call",
              "video",
              "audio",
              "adminGroupEvent",
              "sticker",
              "storyItemReply"
            ]
          }
        },
        fields: {
          quotedMessage: {
            type: "QuotedMessage",
            id: 30
          },
          text: {
            type: "Text",
            id: 10
          },
          blobText: {
            type: "BlobText",
            id: 11
          },
          ping: {
            type: "Ping",
            id: 16
          },
          image: {
            type: "Image",
            id: 17
          },
          location: {
            type: "Location",
            id: 18
          },
          attachment: {
            type: "Attachment",
            id: 19
          },
          contact: {
            type: "Contact",
            id: 20
          },
          timelineForward: {
            type: "TimelineForward",
            id: 21
          },
          groupEvent: {
            type: "GroupEvent",
            id: 22
          },
          superuserProfile: {
            type: "UserProfile",
            id: 23
          },
          superuserPost: {
            type: "UserPost",
            id: 24
          },
          call: {
            type: "Call",
            id: 25
          },
          video: {
            type: "Video",
            id: 26
          },
          audio: {
            type: "Audio",
            id: 27
          },
          adminGroupEvent: {
            type: "AdminGroupEvent",
            id: 28
          },
          sticker: {
            type: "Sticker",
            id: 29
          },
          storyItemReply: {
            type: "StoryItemReply",
            id: 40
          }
        },
        nested: {
          QuotedMessage: {
            fields: {
              messageId: {
                type: "bytes",
                id: 1
              },
              actorId: {
                type: "string",
                id: 2
              },
              createdAtMillis: {
                type: "uint64",
                id: 3
              },
              body: {
                type: "BodyTypes",
                id: 4
              }
            }
          },
          Text: {
            fields: {
              body: {
                rule: "required",
                type: "string",
                id: 1
              },
              linkPreview: {
                type: "LinkPreview",
                id: 2
              },
              mentions: {
                rule: "repeated",
                type: "Mention",
                id: 3
              }
            }
          },
          LinkPreview: {
            fields: {
              imageUrl: {
                type: "string",
                id: 1
              },
              title: {
                type: "string",
                id: 2
              },
              websiteUrl: {
                type: "string",
                id: 3
              },
              originalUrl: {
                type: "string",
                id: 4
              },
              description: {
                type: "string",
                id: 5
              }
            }
          },
          Mention: {
            fields: {
              actorId: {
                type: "string",
                id: 1
              },
              location: {
                type: "uint32",
                id: 2
              },
              length: {
                type: "uint32",
                id: 3
              }
            }
          },
          Sticker: {
            fields: {
              stickerUrl: {
                type: "string",
                id: 1
              },
              stickerWidth: {
                type: "uint32",
                id: 2
              },
              stickerHeight: {
                type: "uint32",
                id: 3
              },
              stickerId: {
                type: "string",
                id: 4
              }
            }
          },
          BlobText: {
            fields: {
              teaser: {
                rule: "required",
                type: "string",
                id: 1
              },
              fileUrl: {
                type: "string",
                id: 2
              }
            }
          },
          StoryItemReply: {
            oneofs: {
              body: {
                oneof: [
                  "image",
                  "video"
                ]
              }
            },
            fields: {
              storyId: {
                type: "string",
                id: 1
              },
              storyItemId: {
                type: "string",
                id: 2
              },
              replyBody: {
                type: "string",
                id: 3
              },
              image: {
                type: "Image",
                id: 6
              },
              video: {
                type: "Video",
                id: 7
              }
            },
            nested: {
              Image: {
                fields: {
                  imageUrl: {
                    type: "string",
                    id: 1
                  },
                  imageWidth: {
                    type: "int32",
                    id: 2
                  },
                  imageHeight: {
                    type: "int32",
                    id: 3
                  }
                }
              },
              Video: {
                fields: {
                  videoUrl: {
                    type: "string",
                    id: 1
                  },
                  mimeType: {
                    type: "string",
                    id: 2
                  },
                  imageWidth: {
                    type: "int32",
                    id: 3
                  },
                  imageHeight: {
                    type: "int32",
                    id: 4
                  },
                  imageUrl: {
                    type: "string",
                    id: 5
                  },
                  videoDuration: {
                    type: "int32",
                    id: 6
                  }
                }
              }
            }
          },
          Ping: {
            fields: {}
          },
          Video: {
            fields: {
              videoUrl: {
                type: "string",
                id: 1
              },
              mimeType: {
                rule: "required",
                type: "string",
                id: 2
              },
              imageWidth: {
                rule: "required",
                type: "int32",
                id: 3
              },
              imageHeight: {
                rule: "required",
                type: "int32",
                id: 4
              },
              imageUrl: {
                type: "string",
                id: 5
              },
              progress: {
                type: "float",
                id: 6
              },
              imageColor: {
                type: "int32",
                id: 7
              },
              imageData: {
                type: "bytes",
                id: 8
              }
            }
          },
          Image: {
            fields: {
              imageUrl: {
                type: "string",
                id: 1
              },
              imageWidth: {
                rule: "required",
                type: "int32",
                id: 2
              },
              imageHeight: {
                rule: "required",
                type: "int32",
                id: 3
              },
              OBSOLETEThumbImageUrl: {
                type: "string",
                id: 4
              },
              progress: {
                type: "float",
                id: 5
              },
              imageColor: {
                type: "int32",
                id: 6
              },
              imageData: {
                type: "bytes",
                id: 7
              }
            }
          },
          Location: {
            fields: {
              latitude: {
                rule: "required",
                type: "float",
                id: 1
              },
              longitude: {
                rule: "required",
                type: "float",
                id: 2
              }
            }
          },
          Attachment: {
            fields: {
              fileUrl: {
                type: "string",
                id: 1
              },
              mimeType: {
                rule: "required",
                type: "string",
                id: 2
              },
              fileSize: {
                type: "uint64",
                id: 4
              },
              progress: {
                type: "float",
                id: 5
              },
              fileName: {
                type: "string",
                id: 6
              }
            }
          },
          Contact: {
            fields: {
              phoneNumber: {
                rule: "required",
                type: "string",
                id: 2
              },
              contactName: {
                rule: "required",
                type: "string",
                id: 3
              }
            }
          },
          TimelineForward: {
            fields: {
              timelineId: {
                rule: "required",
                type: "string",
                id: 1
              }
            }
          },
          UserProfile: {
            fields: {
              userId: {
                rule: "required",
                type: "string",
                id: 1
              }
            }
          },
          UserPost: {
            fields: {
              postId: {
                rule: "required",
                type: "string",
                id: 1
              }
            }
          },
          GroupEvent: {
            fields: {
              type: {
                rule: "required",
                type: "Type",
                id: 2
              },
              targetUserId: {
                rule: "required",
                type: "string",
                id: 3
              }
            },
            nested: {
              Type: {
                values: {
                  CHAT_CREATED_ACTION: 0,
                  USER_LEFT_ACTION: 2,
                  USER_ADDED_ACTION: 1,
                  USER_REMOVED_ACTION: 3
                }
              }
            }
          },
          AdminGroupEvent: {
            fields: {
              type: {
                type: "Type",
                id: 1
              },
              targetUserId: {
                type: "string",
                id: 2
              }
            },
            nested: {
              Type: {
                values: {
                  ADMIN_UNKNOWN_ACTION: 0,
                  ADMIN_ADDED_ACTION: 1,
                  ADMIN_REMOVED_ACTION: 2
                }
              }
            }
          },
          Call: {
            oneofs: {
              status: {
                oneof: [
                  "success",
                  "cancelled",
                  "noAnswer",
                  "denied"
                ]
              }
            },
            fields: {
              type: {
                rule: "required",
                type: "Type",
                id: 1
              },
              success: {
                type: "Success",
                id: 2
              },
              cancelled: {
                type: "Cancelled",
                id: 3
              },
              noAnswer: {
                type: "NoAnswer",
                id: 4
              },
              denied: {
                type: "Denied",
                id: 5
              },
              callId: {
                type: "string",
                id: 6
              }
            },
            nested: {
              Type: {
                values: {
                  VIDEO: 0,
                  VOICE: 1
                }
              },
              Success: {
                fields: {
                  callTimeInMillis: {
                    rule: "required",
                    type: "uint64",
                    id: 1
                  }
                }
              },
              Cancelled: {
                fields: {}
              },
              NoAnswer: {
                fields: {}
              },
              Denied: {
                fields: {}
              }
            }
          },
          Audio: {
            fields: {
              audioUrl: {
                type: "string",
                id: 1
              },
              durationInMillis: {
                rule: "required",
                type: "uint64",
                id: 2
              },
              mimeType: {
                rule: "required",
                type: "string",
                id: 3
              },
              progress: {
                type: "float",
                id: 4
              }
            }
          }
        }
      }
    }
  },
  messages_statuses: {
    options: {
      java_package: "com.appunite.chat.model.statuses",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true
    },
    nested: {
      ConversationReceiptServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          actorId: {
            rule: "required",
            type: "string",
            id: 2
          },
          latestDeliveredMessageCreatedAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          },
          latestReadMessageCreatedAtMillis: {
            type: "uint64",
            id: 4
          },
          unreadMessagesCount: {
            type: "uint64",
            id: 5,
            options: {
              "default": 0
            }
          }
        }
      },
      CurrentUserUnreadMessagesServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          unreadMessagesCount: {
            rule: "required",
            type: "uint64",
            id: 3
          },
          latestReadMessageCreatedAtMillis: {
            type: "uint64",
            id: 5
          }
        }
      },
      UpdateConversationDeliveredClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 3
          }
        }
      },
      UpdateConversationReadClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 3
          }
        }
      },
      UpdateConversationReadConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          }
        }
      }
    }
  },
  rpc: {
    options: {
      java_package: "com.appunite.chat.model.rpc",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true
    },
    nested: {
      RpcGetAllConversationsServerResponse: {
        fields: {
          nextSynchronizationToken: {
            rule: "required",
            type: "string",
            id: 1
          },
          currentUserIdentifier: {
            rule: "required",
            type: "string",
            id: 2
          },
          conversations: {
            rule: "repeated",
            type: "ConversationWithLastMessage",
            id: 3
          }
        }
      },
      ConversationWithLastMessage: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          },
          lastMessage: {
            type: "messages.CreateMessageServerMessage",
            id: 2
          },
          messagesStatuses: {
            rule: "repeated",
            type: "messages_statuses.ConversationReceiptServerMessage",
            id: 3
          },
          currentUserMessagesStatuses: {
            type: "messages_statuses.CurrentUserUnreadMessagesServerMessage",
            id: 4
          }
        }
      },
      RpcGetMessagesServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          },
          hasMore: {
            rule: "required",
            type: "bool",
            id: 2
          }
        }
      },
      RpcGetMessagesDeltaServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          },
          hasMoreOlderMessages: {
            type: "bool",
            id: 2
          },
          hasMoreNewerMessages: {
            type: "bool",
            id: 3
          }
        }
      },
      RpcGetAllBlockedUsersServerResponse: {
        fields: {
          users: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      },
      RpcStarMessageServerResponse: {
        fields: {}
      },
      RpcUnstarMessageServerResponse: {
        fields: {}
      },
      RpcGetAllStarredConversationsServerResponse: {
        fields: {
          conversations: {
            rule: "repeated",
            type: "ConversationWithStarredMessageIds",
            id: 1
          },
          nextToken: {
            type: "string",
            id: 2
          }
        }
      },
      ConversationWithStarredMessageIds: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          },
          messageIds: {
            rule: "repeated",
            type: "bytes",
            id: 2
          }
        }
      },
      RpcGetAllStarredMessagesServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          }
        }
      },
      RpcLikeMessageServerResponse: {
        fields: {}
      },
      RpcDislikeMessageServerResponse: {
        fields: {}
      },
      RpcSendMessageClientRequest: {
        fields: {
          body: {
            rule: "required",
            type: "messages.BodyTypes",
            id: 1
          }
        }
      },
      RpcSendMessageServerResponse: {
        fields: {}
      },
      RpcConversationJoinLinkServerResponse: {
        fields: {
          conversationId: {
            type: "bytes",
            id: 1
          },
          url: {
            type: "string",
            id: 2
          }
        }
      },
      RpcJoinConversationMetadataServerResponse: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          }
        }
      },
      RpcJoinConversationClientRequest: {
        fields: {
          joinLink: {
            rule: "required",
            type: "string",
            id: 1
          }
        }
      },
      RpcJoinConversationServerResponse: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          }
        }
      },
      RpcSearchMessagesServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          },
          conversations: {
            rule: "repeated",
            type: "conversations.CreateConversationServerMessage",
            id: 2
          },
          nextToken: {
            type: "string",
            id: 3
          }
        }
      }
    }
  },
  authentication: {
    nested: {
      SignUpRequest: {
        oneofs: {
          method: {
            oneof: [
              "email",
              "phone",
              "facebook"
            ]
          }
        },
        fields: {
          clientId: {
            type: "string",
            id: 1
          },
          scopes: {
            rule: "repeated",
            type: "string",
            id: 2
          },
          email: {
            type: "EmailSignUpData",
            id: 3
          },
          phone: {
            type: "PhoneSignUpData",
            id: 4
          },
          facebook: {
            type: "FacebookSignUpData",
            id: 5
          }
        },
        nested: {
          EmailSignUpData: {
            fields: {
              email: {
                type: "string",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              username: {
                type: "string",
                id: 3
              },
              password: {
                type: "string",
                id: 4
              }
            }
          },
          PhoneSignUpData: {
            fields: {
              countryCode: {
                type: "string",
                id: 1
              },
              phone: {
                type: "string",
                id: 2
              },
              name: {
                type: "string",
                id: 3
              },
              username: {
                type: "string",
                id: 4
              },
              password: {
                type: "string",
                id: 5
              },
              firebaseToken: {
                type: "string",
                id: 6
              }
            }
          },
          FacebookSignUpData: {
            fields: {
              facebookToken: {
                type: "string",
                id: 1
              }
            }
          }
        }
      },
      SignUpResponse: {
        oneofs: {
          response: {
            oneof: [
              "token",
              "unconfirmed"
            ]
          }
        },
        fields: {
          token: {
            type: "com.newmedia.auth.model.TokenResponse",
            id: 1
          },
          unconfirmed: {
            type: "ConfirmationRequired",
            id: 2
          }
        },
        nested: {
          ConfirmationRequired: {
            fields: {
              message: {
                type: "string",
                id: 1
              }
            }
          }
        }
      },
      SignUpError: {
        fields: {
          code: {
            type: "ErrorCode",
            id: 1
          },
          message: {
            type: "string",
            id: 2
          }
        },
        nested: {
          ErrorCode: {
            values: {
              UNKNOWN: 0,
              PERFORMED_BY_UNAUTHORIZED_APP: 1,
              UNAVAILABLE_SCOPE_REQUESTED: 2,
              VALIDATION_FAILED: 3,
              FB_CONNECTION_FAILURE: 4,
              FIREBASE_AUTH_ERROR: 5,
              FACEBOOK_ID_ALREADY_TAKEN: 6
            }
          }
        }
      },
      LogInRequest: {
        oneofs: {
          method: {
            oneof: [
              "email",
              "phone",
              "facebook",
              "username",
              "firebaseAuth"
            ]
          }
        },
        fields: {
          clientId: {
            type: "string",
            id: 1
          },
          scopes: {
            rule: "repeated",
            type: "string",
            id: 2
          },
          email: {
            type: "EmailLogInData",
            id: 3
          },
          phone: {
            type: "PhoneLogInData",
            id: 4
          },
          facebook: {
            type: "FacebookLogInData",
            id: 5
          },
          username: {
            type: "UsernameLogInData",
            id: 6
          },
          firebaseAuth: {
            type: "FirebaseAuthLogInData",
            id: 7
          }
        },
        nested: {
          EmailLogInData: {
            fields: {
              email: {
                type: "string",
                id: 1
              },
              password: {
                type: "string",
                id: 2
              }
            }
          },
          PhoneLogInData: {
            fields: {
              phoneNumber: {
                type: "string",
                id: 1
              },
              password: {
                type: "string",
                id: 2
              }
            }
          },
          FacebookLogInData: {
            fields: {
              facebookToken: {
                type: "string",
                id: 1
              }
            }
          },
          UsernameLogInData: {
            fields: {
              username: {
                type: "string",
                id: 2
              },
              password: {
                type: "string",
                id: 3
              }
            }
          },
          FirebaseAuthLogInData: {
            fields: {
              phoneNumber: {
                type: "string",
                id: 1
              },
              firebaseToken: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      LogInResponse: {
        fields: {
          token: {
            type: "com.newmedia.auth.model.TokenResponse",
            id: 1
          }
        }
      },
      LogInError: {
        fields: {
          code: {
            type: "ErrorCode",
            id: 1
          },
          message: {
            type: "string",
            id: 2
          }
        },
        nested: {
          ErrorCode: {
            values: {
              UNKNOWN: 0,
              PERFORMED_BY_UNAUTHORIZED_APP: 1,
              UNAVAILABLE_SCOPE_REQUESTED: 2,
              INVALID_EMAIL_AUTHENTICATION: 3,
              INVALID_PHONE_AUTHENTICATION: 4,
              INVALID_FACEBOOK_AUTHENTICATION: 5,
              INVALID_USERNAME_AUTHENTICATION: 6,
              UNCONFIRMED_USER: 7,
              FB_CONNECTION_FAILURE: 8,
              UNKNOWN_PHONE_NUMBER: 9,
              FIREBASE_AUTH_ERROR: 10
            }
          }
        }
      },
      LegacyTokensResponse: {
        fields: {
          xAuthToken: {
            type: "string",
            id: 1
          }
        }
      },
      TokenUpgradeRequest: {
        fields: {
          clientId: {
            type: "string",
            id: 1
          },
          scopes: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      },
      TokenUpgradeResponse: {
        fields: {
          token: {
            type: "com.newmedia.auth.model.TokenResponse",
            id: 1
          }
        }
      },
      TokenUpgradeError: {
        fields: {
          code: {
            type: "ErrorCode",
            id: 1
          },
          message: {
            type: "string",
            id: 2
          }
        },
        nested: {
          ErrorCode: {
            values: {
              UNKNOWN: 0,
              PERFORMED_BY_UNAUTHORIZED_APP: 1,
              UNAVAILABLE_SCOPE_REQUESTED: 2
            }
          }
        }
      },
      RecoverPasswordRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          }
        }
      },
      RecoverPasswordResponse: {
        fields: {}
      },
      CountryCode: {
        fields: {
          countryCode: {
            type: "string",
            id: 1
          }
        }
      },
      ResendEmailRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          }
        }
      },
      ResendEmailResponse: {
        fields: {}
      }
    }
  },
  com: {
    nested: {
      newmedia: {
        nested: {
          auth: {
            nested: {
              model: {
                nested: {
                  ApplicationRequest: {
                    fields: {
                      applicationData: {
                        type: "ApplicationData",
                        id: 4
                      }
                    }
                  },
                  ApplicationResponse: {
                    fields: {
                      applicationName: {
                        type: "string",
                        id: 1
                      },
                      applicationUrl: {
                        type: "string",
                        id: 2
                      },
                      applicationAuthenticated: {
                        type: "bool",
                        id: 3
                      }
                    }
                  },
                  ApplicationError: {
                    fields: {
                      code: {
                        type: "ErrorCode",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      ErrorCode: {
                        values: {
                          UNKNOWN: 0,
                          WRONG_APPLICATION_DATA: 1
                        }
                      }
                    }
                  },
                  AuthRequest: {
                    fields: {
                      scope: {
                        rule: "repeated",
                        type: "string",
                        id: 1
                      },
                      responseType: {
                        type: "ResponseType",
                        id: 2
                      },
                      applicationData: {
                        type: "ApplicationData",
                        id: 4
                      }
                    },
                    nested: {
                      ResponseType: {
                        values: {
                          UNKNOWN: 0,
                          CODE: 1
                        }
                      }
                    }
                  },
                  AuthResponse: {
                    fields: {
                      code: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  AuthError: {
                    fields: {
                      code: {
                        type: "ErrorCode",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      ErrorCode: {
                        values: {
                          UNKNOWN: 0,
                          WRONG_APPLICATION_DATA: 1
                        }
                      }
                    }
                  },
                  TokenRequest: {
                    fields: {
                      clientId: {
                        type: "string",
                        id: 1
                      },
                      grantType: {
                        type: "GrantType",
                        id: 2
                      },
                      code: {
                        type: "string",
                        id: 3
                      },
                      refreshToken: {
                        type: "string",
                        id: 4
                      }
                    },
                    nested: {
                      GrantType: {
                        values: {
                          UNKNOWN: 0,
                          CODE: 1,
                          REFRESH_TOKEN: 2
                        }
                      }
                    }
                  },
                  TokenResponse: {
                    fields: {
                      accessToken: {
                        type: "string",
                        id: 1
                      },
                      expiresInMillis: {
                        type: "uint32",
                        id: 2
                      },
                      refreshToken: {
                        type: "string",
                        id: 3
                      }
                    }
                  },
                  TokenError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          LOGGED_OUT: 1
                        }
                      }
                    }
                  },
                  CertsResponse: {
                    fields: {
                      certificates: {
                        rule: "repeated",
                        type: "Certificate",
                        id: 1
                      }
                    },
                    nested: {
                      Certificate: {
                        fields: {
                          kid: {
                            type: "string",
                            id: 1
                          },
                          pemCertificate: {
                            type: "string",
                            id: 2
                          }
                        }
                      }
                    }
                  },
                  ApplicationData: {
                    oneofs: {
                      applicationData: {
                        oneof: [
                          "ios",
                          "android"
                        ]
                      }
                    },
                    fields: {
                      ios: {
                        type: "Ios",
                        id: 1
                      },
                      android: {
                        type: "Android",
                        id: 2
                      }
                    },
                    nested: {
                      Ios: {
                        fields: {
                          clientId: {
                            type: "string",
                            id: 1
                          },
                          redirectUri: {
                            type: "string",
                            id: 2
                          },
                          applicationBundleId: {
                            type: "string",
                            id: 3
                          }
                        }
                      },
                      Android: {
                        fields: {
                          clientId: {
                            type: "string",
                            id: 1
                          },
                          packageName: {
                            type: "string",
                            id: 2
                          },
                          applicationSignatureSha1: {
                            type: "string",
                            id: 3
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          conference: {
            nested: {
              model: {
                nested: {
                  PutBuyRequest: {
                    oneofs: {
                      subscription: {
                        oneof: [
                          "androidSubscription",
                          "iosSubscription"
                        ]
                      }
                    },
                    fields: {
                      force: {
                        type: "bool",
                        id: 2
                      },
                      androidSubscription: {
                        type: "AndroidSubscription",
                        id: 3
                      },
                      iosSubscription: {
                        type: "IosSubscription",
                        id: 4
                      }
                    },
                    nested: {
                      AndroidSubscription: {
                        fields: {
                          packageName: {
                            type: "string",
                            id: 3
                          },
                          productId: {
                            type: "string",
                            id: 1
                          },
                          token: {
                            type: "string",
                            id: 2
                          }
                        }
                      },
                      IosSubscription: {
                        fields: {
                          productId: {
                            type: "string",
                            id: 1
                          },
                          receipt: {
                            type: "string",
                            id: 2
                          },
                          password: {
                            type: "string",
                            id: 3
                          }
                        }
                      }
                    }
                  },
                  PutBuyResponse: {
                    fields: {
                      subscrption: {
                        type: "Subscription",
                        id: 1
                      }
                    }
                  },
                  PutBuyError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          ASIGNED_TO_OTHER_USER: 1,
                          ANDROID_WRONG_SUBSCRIPTION_ID: 2,
                          ANDROID_WRONG_TOKEN: 3
                        }
                      }
                    }
                  },
                  BuyResponse: {
                    fields: {
                      subscription: {
                        type: "Subscription",
                        id: 1
                      }
                    }
                  },
                  BuyError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0
                        }
                      }
                    }
                  },
                  Subscription: {
                    fields: {
                      active: {
                        type: "bool",
                        id: 1
                      },
                      expireTimeMillis: {
                        type: "uint64",
                        id: 2
                      },
                      autoRenewing: {
                        type: "bool",
                        id: 3
                      }
                    }
                  },
                  CallChannel: {
                    fields: {
                      topic: {
                        type: "string",
                        id: 1
                      },
                      event: {
                        type: "string",
                        id: 2
                      },
                      payload: {
                        type: "CallPayload",
                        id: 3
                      },
                      reference: {
                        type: "string",
                        id: 4
                      }
                    }
                  },
                  CallPayload: {
                    oneofs: {
                      message: {
                        oneof: [
                          "participantsCount"
                        ]
                      }
                    },
                    fields: {
                      participantsCount: {
                        type: "ParticipantsCountResponses",
                        id: 1
                      }
                    },
                    nested: {
                      ParticipantsCountResponses: {
                        oneofs: {
                          message: {
                            oneof: [
                              "update",
                              "error"
                            ]
                          }
                        },
                        fields: {
                          update: {
                            type: "Update",
                            id: 1
                          },
                          error: {
                            type: "Error",
                            id: 2
                          }
                        },
                        nested: {
                          Update: {
                            fields: {
                              count: {
                                type: "uint32",
                                id: 3
                              }
                            }
                          },
                          Error: {
                            fields: {
                              code: {
                                type: "Code",
                                id: 1
                              },
                              userMessage: {
                                type: "string",
                                id: 2
                              }
                            },
                            nested: {
                              Code: {
                                values: {
                                  UNKNOWN: 0,
                                  ERROR_YOU_ARE_NOT_AN_ADMIN: 1
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  CreateSlotRequest: {
                    fields: {
                      username: {
                        type: "string",
                        id: 1
                      },
                      pin: {
                        type: "string",
                        id: 2
                      }
                    }
                  },
                  CreateSlotResponse: {
                    fields: {
                      slotId: {
                        type: "string",
                        id: 1
                      },
                      iceServers: {
                        rule: "repeated",
                        type: "IceServer",
                        id: 2
                      },
                      chatChannelName: {
                        type: "string",
                        id: 3
                      }
                    }
                  },
                  CreateSlotError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          INCORRECT_URL_OR_PIN: 1,
                          ROOM_LOCKED: 2,
                          NO_MORE_SLOTS: 3,
                          BROADCAST_IN_PROGRESS: 4
                        }
                      }
                    }
                  },
                  PutAdminRequest: {
                    fields: {
                      isAdmin: {
                        type: "bool",
                        id: 1
                      }
                    }
                  },
                  PutAdminResponse: {
                    fields: {}
                  },
                  PutAdminError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1,
                          YOU_CAN_CHANGE_RIGHTS_TO_OWNER: 2,
                          USER_IS_NOT_IN_CALL: 3
                        }
                      }
                    }
                  },
                  MuteRequest: {
                    fields: {
                      mute: {
                        type: "bool",
                        id: 1
                      }
                    }
                  },
                  MuteResponse: {
                    fields: {}
                  },
                  MuteError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_IN_CALL: 1
                        }
                      }
                    }
                  },
                  LockRequest: {
                    fields: {
                      lock: {
                        type: "bool",
                        id: 1
                      }
                    }
                  },
                  LockResponse: {
                    fields: {}
                  },
                  LockError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1
                        }
                      }
                    }
                  },
                  TitleRequest: {
                    fields: {
                      title: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  TitleResponse: {
                    fields: {}
                  },
                  TitleError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1
                        }
                      }
                    }
                  },
                  MuteAllRequest: {
                    fields: {}
                  },
                  MuteAllResponse: {
                    fields: {}
                  },
                  MuteAllError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1
                        }
                      }
                    }
                  },
                  MuteUserRequest: {
                    fields: {
                      userId: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  MuteUserResponse: {
                    fields: {}
                  },
                  MuteUserError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1
                        }
                      }
                    }
                  },
                  UnmuteUserRequest: {
                    fields: {
                      userId: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  UnmuteUserResponse: {
                    fields: {}
                  },
                  UnmuteUserError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1
                        }
                      }
                    }
                  },
                  KickUserRequest: {
                    fields: {
                      userId: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  KickUserResponse: {
                    fields: {}
                  },
                  KickUserError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1,
                          ADMIN_CANT_KICK_ADMIN: 2
                        }
                      }
                    }
                  },
                  EndConferenceRequest: {
                    fields: {}
                  },
                  EndConferenceResponse: {
                    fields: {}
                  },
                  EndConferenceError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0
                        }
                      }
                    }
                  },
                  EndSlotRequest: {
                    fields: {
                      reason: {
                        type: "Reason",
                        id: 1
                      },
                      clientMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Reason: {
                        values: {
                          UNKNOWN: 0,
                          USER_REQUESTED_END: 1,
                          WEBRTC_INITIALIZATION_ERROR: 2
                        }
                      }
                    }
                  },
                  EndSlotResponse: {
                    fields: {}
                  },
                  EndSlotError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0
                        }
                      }
                    }
                  },
                  ConnectResponses: {
                    oneofs: {
                      message: {
                        oneof: [
                          "slotEnded",
                          "pong",
                          "webrtcMessage",
                          "updateStatus",
                          "adminMutedAllParticipants",
                          "updateCredentials",
                          "receivedAdminRights"
                        ]
                      }
                    },
                    fields: {
                      slotEnded: {
                        type: "SlotEnded",
                        id: 1
                      },
                      pong: {
                        type: "PongMessage",
                        id: 2
                      },
                      webrtcMessage: {
                        type: "WebrtcMessage",
                        id: 3
                      },
                      updateStatus: {
                        type: "UpdateStatus",
                        id: 4
                      },
                      adminMutedAllParticipants: {
                        type: "AdminMutedAllParticipants",
                        id: 5
                      },
                      updateCredentials: {
                        type: "UpdateCredentials",
                        id: 6
                      },
                      receivedAdminRights: {
                        type: "ReceivedAdminRights",
                        id: 16
                      }
                    },
                    nested: {
                      UpdateStatus: {
                        fields: {
                          participants: {
                            rule: "repeated",
                            type: "Participant",
                            id: 1
                          },
                          title: {
                            type: "string",
                            id: 2
                          },
                          locked: {
                            type: "bool",
                            id: 3
                          },
                          started: {
                            type: "bool",
                            id: 4
                          },
                          ownerUserId: {
                            type: "string",
                            id: 5
                          },
                          connectedUserId: {
                            type: "string",
                            id: 6
                          },
                          freeCall: {
                            type: "bool",
                            id: 7
                          },
                          username: {
                            type: "string",
                            id: 20
                          },
                          conferenceUrl: {
                            type: "string",
                            id: 21
                          },
                          conferencePin: {
                            type: "string",
                            id: 22
                          },
                          listeningMode: {
                            type: "bool",
                            id: 23
                          }
                        },
                        nested: {
                          Participant: {
                            fields: {
                              userId: {
                                type: "string",
                                id: 1
                              },
                              isAdmin: {
                                type: "bool",
                                id: 2
                              },
                              isMuted: {
                                type: "bool",
                                id: 3
                              },
                              isOnline: {
                                type: "bool",
                                id: 4
                              },
                              isTalking: {
                                type: "bool",
                                id: 5
                              }
                            }
                          }
                        }
                      },
                      SlotEnded: {
                        fields: {
                          code: {
                            type: "Code",
                            id: 1
                          },
                          userMessage: {
                            type: "string",
                            id: 2
                          },
                          callDurationInMillis: {
                            type: "uint64",
                            id: 3
                          }
                        },
                        nested: {
                          Code: {
                            values: {
                              UNKNOWN: 0,
                              CALL_ENDED_BY_ADMINISTRATOR: 1,
                              YOU_WERE_KICKED: 2,
                              USER_REQUESTED_END: 3,
                              WEBRTC_INITIALIZATION_ERROR: 5,
                              BROADCAST_IN_PROGRESS: 6
                            }
                          }
                        }
                      },
                      PongMessage: {
                        fields: {
                          data: {
                            type: "string",
                            id: 1
                          }
                        }
                      },
                      WebrtcMessage: {
                        fields: {
                          sequence: {
                            type: "uint32",
                            id: 1
                          },
                          data: {
                            type: "DataMessage",
                            id: 2
                          }
                        }
                      },
                      AdminMutedAllParticipants: {
                        fields: {
                          whoUserId: {
                            type: "string",
                            id: 1
                          }
                        }
                      },
                      ReceivedAdminRights: {
                        fields: {
                          whoUserId: {
                            type: "string",
                            id: 1
                          }
                        }
                      },
                      UpdateCredentials: {
                        fields: {
                          username: {
                            type: "string",
                            id: 1
                          },
                          conferenceUrl: {
                            type: "string",
                            id: 2
                          },
                          conferencePin: {
                            type: "string",
                            id: 3
                          }
                        }
                      }
                    }
                  },
                  ConnectRequests: {
                    oneofs: {
                      message: {
                        oneof: [
                          "ping",
                          "webrtcMessage",
                          "speaking"
                        ]
                      }
                    },
                    fields: {
                      ping: {
                        type: "PingMessage",
                        id: 1
                      },
                      webrtcMessage: {
                        type: "WebrtcMessage",
                        id: 2
                      },
                      speaking: {
                        type: "SpeakingMessage",
                        id: 3
                      }
                    },
                    nested: {
                      PingMessage: {
                        fields: {
                          data: {
                            type: "string",
                            id: 1
                          }
                        }
                      },
                      SpeakingMessage: {
                        fields: {
                          speaking: {
                            type: "bool",
                            id: 1
                          }
                        }
                      },
                      WebrtcMessage: {
                        fields: {
                          sequence: {
                            type: "uint32",
                            id: 1
                          },
                          data: {
                            type: "DataMessage",
                            id: 2
                          }
                        }
                      }
                    }
                  },
                  IceServer: {
                    fields: {
                      uri: {
                        type: "string",
                        id: 1
                      },
                      username: {
                        type: "string",
                        id: 2
                      },
                      password: {
                        type: "string",
                        id: 3
                      }
                    }
                  },
                  DataMessage: {
                    oneofs: {
                      data: {
                        oneof: [
                          "sessionsDescription",
                          "iceCandidateAdd",
                          "iceCandidateRemoved"
                        ]
                      }
                    },
                    fields: {
                      sessionsDescription: {
                        type: "SessionDescription",
                        id: 1
                      },
                      iceCandidateAdd: {
                        type: "IceCandidateAdd",
                        id: 2
                      },
                      iceCandidateRemoved: {
                        type: "IceCandidateRemoved",
                        id: 3
                      }
                    },
                    nested: {
                      SessionDescription: {
                        fields: {
                          type: {
                            type: "Type",
                            id: 1
                          },
                          description: {
                            type: "string",
                            id: 2
                          }
                        },
                        nested: {
                          Type: {
                            values: {
                              UNKNOWN: 0,
                              OFFER: 1,
                              PRANSWER: 2,
                              ANSWER: 3
                            }
                          }
                        }
                      },
                      IceCandidate: {
                        fields: {
                          sdpMid: {
                            type: "string",
                            id: 1
                          },
                          sdpMLineIndex: {
                            type: "int32",
                            id: 2
                          },
                          sdp: {
                            type: "string",
                            id: 3
                          }
                        }
                      },
                      IceCandidateAdd: {
                        fields: {
                          iceCandidate: {
                            rule: "repeated",
                            type: "IceCandidate",
                            id: 1
                          }
                        }
                      },
                      IceCandidateRemoved: {
                        fields: {
                          iceCandidate: {
                            rule: "repeated",
                            type: "IceCandidate",
                            id: 2
                          }
                        }
                      }
                    }
                  },
                  PutMessageRequest: {
                    fields: {
                      message: {
                        type: "Message",
                        id: 1
                      }
                    }
                  },
                  PutMessageResponse: {
                    fields: {
                      message: {
                        type: "Message",
                        id: 1
                      }
                    }
                  },
                  PutMessageError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_IN_CALL: 1,
                          YOU_ARE_TRIED_TO_UPDATE_OTHER_USER_MESSAGE: 2
                        }
                      }
                    }
                  },
                  ChatChannel: {
                    fields: {
                      topic: {
                        type: "string",
                        id: 1
                      },
                      event: {
                        type: "string",
                        id: 2
                      },
                      payload: {
                        type: "ChatPayload",
                        id: 3
                      },
                      reference: {
                        type: "string",
                        id: 4
                      }
                    }
                  },
                  ChatPayload: {
                    oneofs: {
                      messages: {
                        oneof: [
                          "chat"
                        ]
                      }
                    },
                    fields: {
                      chat: {
                        type: "ChatResponses",
                        id: 1
                      }
                    },
                    nested: {
                      ChatResponses: {
                        oneofs: {
                          message: {
                            oneof: [
                              "firstResponse",
                              "newMessage",
                              "updateMessage",
                              "slotEnded"
                            ]
                          }
                        },
                        fields: {
                          firstResponse: {
                            type: "ChatResponse",
                            id: 1
                          },
                          newMessage: {
                            type: "Message",
                            id: 2
                          },
                          updateMessage: {
                            type: "Message",
                            id: 3
                          },
                          slotEnded: {
                            type: "com.newmedia.conference.model.ConnectResponses.SlotEnded",
                            id: 4
                          }
                        }
                      }
                    }
                  },
                  ChatResponse: {
                    fields: {
                      messages: {
                        rule: "repeated",
                        type: "Message",
                        id: 1
                      },
                      nextToken: {
                        type: "string",
                        id: 2
                      }
                    }
                  },
                  ChatError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_IN_CALL: 1
                        }
                      }
                    }
                  },
                  Message: {
                    fields: {
                      messageId: {
                        type: "bytes",
                        id: 1
                      },
                      createdAtMillis: {
                        type: "uint64",
                        id: 2
                      },
                      creatorId: {
                        type: "string",
                        id: 3
                      },
                      bodyType: {
                        type: "bytes",
                        id: 5
                      },
                      deleted: {
                        type: "bool",
                        id: 6
                      }
                    }
                  },
                  HistoryResponse: {
                    fields: {
                      entries: {
                        rule: "repeated",
                        type: "HistoryEntry",
                        id: 1
                      },
                      nextToken: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      HistoryEntry: {
                        fields: {
                          startTimeInMillis: {
                            type: "uint64",
                            id: 1
                          },
                          endTimeInMillis: {
                            type: "uint64",
                            id: 2
                          },
                          title: {
                            type: "string",
                            id: 3
                          },
                          attendeesUserIds: {
                            rule: "repeated",
                            type: "string",
                            id: 4
                          }
                        }
                      }
                    }
                  },
                  NotificationRegisterRequest: {
                    fields: {
                      uniqueDeviceId: {
                        type: "string",
                        id: 1
                      },
                      instanceIdToken: {
                        type: "string",
                        id: 2
                      }
                    }
                  },
                  NotificationRegisterResponse: {
                    fields: {}
                  },
                  NotificationRegisterError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0
                        }
                      }
                    }
                  },
                  NotificationMessage: {
                    oneofs: {
                      message: {
                        oneof: [
                          "waitingParticipants"
                        ]
                      }
                    },
                    fields: {
                      waitingParticipants: {
                        type: "WaitingParticipants",
                        id: 1
                      }
                    },
                    nested: {
                      WaitingParticipants: {
                        fields: {
                          count: {
                            type: "int32",
                            id: 1
                          },
                          roomStarted: {
                            type: "bool",
                            id: 2
                          },
                          ownerInRoom: {
                            type: "bool",
                            id: 3
                          }
                        }
                      }
                    }
                  },
                  CurrentUserResponse: {
                    fields: {
                      currentUser: {
                        type: "CurrentUser",
                        id: 1
                      }
                    }
                  },
                  PutUsernameRequest: {
                    fields: {
                      username: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  PutUsernameResponse: {
                    fields: {
                      currentUser: {
                        type: "CurrentUser",
                        id: 1
                      }
                    }
                  },
                  PutUsernameUrlError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          EMPTY_USERNAME: 1,
                          INCORRECT_CHARACTER_IN_USERNAME: 2
                        }
                      }
                    }
                  },
                  PutConferencePinRequest: {
                    fields: {
                      conferencePin: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  PutConferencePinResponse: {
                    fields: {
                      currentUser: {
                        type: "CurrentUser",
                        id: 1
                      }
                    }
                  },
                  PutConferencePinError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          EMPTY_PIN: 1,
                          INCORRECT_CHARACTER_IN_PIN: 2,
                          PIN_TOO_SHORT: 3,
                          PIN_TOO_LONG: 4
                        }
                      }
                    }
                  },
                  CurrentUser: {
                    fields: {
                      userId: {
                        type: "string",
                        id: 1
                      },
                      name: {
                        type: "string",
                        id: 2
                      },
                      username: {
                        type: "string",
                        id: 3
                      },
                      avatarUrl: {
                        type: "string",
                        id: 7
                      },
                      conferenceUrl: {
                        type: "string",
                        id: 5
                      },
                      conferencePin: {
                        type: "string",
                        id: 6
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  contact: {
    options: {
      java_package: "com.appunite.user.model",
      java_multiple_files: true,
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true
    },
    nested: {
      ContactsRequest: {
        fields: {
          contacts: {
            rule: "repeated",
            type: "DeviceContact",
            id: 1
          }
        },
        nested: {
          DeviceContact: {
            fields: {
              phoneHash: {
                rule: "required",
                type: "string",
                id: 2
              },
              contactName: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      ContactsResponse: {
        fields: {
          contacts: {
            rule: "repeated",
            type: "ContactMessage",
            id: 1
          },
          users: {
            rule: "repeated",
            type: "user.User",
            id: 2
          }
        },
        nested: {
          ContactMessage: {
            fields: {
              userId: {
                rule: "required",
                type: "string",
                id: 1
              },
              phoneHash: {
                rule: "required",
                type: "string",
                id: 2
              },
              contactName: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      AddContactRequest: {
        fields: {
          userId: {
            rule: "required",
            type: "string",
            id: 1
          }
        }
      },
      AddContactResponse: {
        fields: {
          userId: {
            rule: "required",
            type: "string",
            id: 1
          }
        }
      }
    }
  },
  user: {
    options: {
      java_package: "com.appunite.user.model",
      java_multiple_files: true,
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true,
      java_outer_classname: "UserModule"
    },
    nested: {
      PresenceMessage: {
        oneofs: {
          presence: {
            oneof: [
              "online",
              "offline",
              "neverSeen"
            ]
          }
        },
        fields: {
          online: {
            type: "Online",
            id: 2
          },
          offline: {
            type: "Offline",
            id: 3
          },
          neverSeen: {
            type: "NeverSeen",
            id: 4
          }
        },
        nested: {
          Online: {
            fields: {}
          },
          Offline: {
            fields: {
              lastSeenInMillis: {
                rule: "required",
                type: "int64",
                id: 1
              }
            }
          },
          NeverSeen: {
            fields: {}
          }
        }
      },
      User: {
        fields: {
          userId: {
            rule: "required",
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          username: {
            type: "string",
            id: 3
          },
          postsCount: {
            type: "int32",
            id: 4
          },
          superuser: {
            type: "Superuser",
            id: 5
          },
          userBio: {
            type: "string",
            id: 6
          },
          avatarUrl: {
            type: "string",
            id: 7
          },
          avatarMainColor: {
            type: "int32",
            id: 8
          },
          privateAccount: {
            type: "bool",
            id: 9,
            options: {
              "default": false
            }
          },
          badgeIds: {
            rule: "repeated",
            type: "string",
            id: 10
          },
          presence: {
            type: "PresenceMessage",
            id: 11
          }
        },
        nested: {
          Superuser: {
            fields: {
              DEPRECATEDWebsiteUrl: {
                type: "string",
                id: 1
              },
              location: {
                type: "string",
                id: 2
              },
              coverUrl: {
                type: "string",
                id: 3
              },
              accountType: {
                type: "string",
                id: 4
              },
              followersCount: {
                type: "int32",
                id: 5
              }
            }
          }
        }
      },
      UserResponse: {
        fields: {
          user: {
            rule: "required",
            type: "user.User",
            id: 1
          }
        }
      }
    }
  },
  protocols: {
    nested: {
      broadcast: {
        nested: {
          Broadcast: {
            fields: {
              username: {
                type: "string",
                id: 1
              },
              pin: {
                type: "string",
                id: 2
              }
            }
          },
          BroadcastStream: {
            fields: {
              broadcastType: {
                type: "Type",
                id: 1
              },
              broadcastUrl: {
                type: "string",
                id: 2
              }
            },
            nested: {
              Type: {
                values: {
                  UNKNOWN: 0,
                  RTSP: 1
                }
              }
            }
          },
          BroadcastSlot: {
            fields: {
              broadcastSlotId: {
                type: "string",
                id: 1
              },
              broadcastChatName: {
                type: "string",
                id: 2
              }
            }
          },
          BroadcastListenersCounter: {
            fields: {
              count: {
                type: "uint32",
                id: 1
              }
            }
          },
          CreateBroadcastSlotRequest: {
            fields: {
              broadcast: {
                type: "Broadcast",
                id: 1
              }
            }
          },
          CreateBroadcastSlotResponse: {
            fields: {
              broadcastSlot: {
                type: "BroadcastSlot",
                id: 1
              }
            }
          },
          CreateBroadcastSlotError: {
            fields: {
              code: {
                type: "Code",
                id: 1
              },
              userMessage: {
                type: "string",
                id: 2
              }
            },
            nested: {
              Code: {
                values: {
                  UNKNOWN: 0,
                  INVALID_PIN: 1
                }
              }
            }
          },
          StartBroadcastRequest: {
            fields: {
              stream: {
                type: "BroadcastStream",
                id: 1
              }
            }
          },
          BroadcastStatusUpdateResponse: {
            oneofs: {
              message: {
                oneof: [
                  "update",
                  "pong"
                ]
              }
            },
            fields: {
              update: {
                type: "UpdateMessage",
                id: 1
              },
              pong: {
                type: "PongMessage",
                id: 2
              }
            },
            nested: {
              UpdateMessage: {
                fields: {
                  stream: {
                    type: "BroadcastStream",
                    id: 1
                  },
                  listenersCounter: {
                    type: "BroadcastListenersCounter",
                    id: 2
                  }
                }
              },
              PongMessage: {
                fields: {
                  data: {
                    type: "string",
                    id: 1
                  }
                }
              }
            }
          },
          BroadcastStatusUpdateRequest: {
            oneofs: {
              message: {
                oneof: [
                  "ping"
                ]
              }
            },
            fields: {
              ping: {
                type: "PingMessage",
                id: 1
              }
            },
            nested: {
              PingMessage: {
                fields: {
                  data: {
                    type: "string",
                    id: 1
                  }
                }
              }
            }
          },
          Message: {
            fields: {
              creatorId: {
                type: "string",
                id: 1
              },
              createdAtMillis: {
                type: "uint64",
                id: 2
              },
              bodyType: {
                type: "bytes",
                id: 3
              }
            }
          },
          BroadcastChatChannel: {
            fields: {
              topic: {
                type: "string",
                id: 1
              },
              event: {
                type: "string",
                id: 2
              },
              payload: {
                type: "Payload",
                id: 3
              },
              reference: {
                type: "string",
                id: 4
              }
            },
            nested: {
              Payload: {
                oneofs: {
                  message: {
                    oneof: [
                      "chat"
                    ]
                  }
                },
                fields: {
                  chat: {
                    type: "ChatResponses",
                    id: 1
                  }
                },
                nested: {
                  ChatResponses: {
                    oneofs: {
                      message: {
                        oneof: [
                          "newMessage"
                        ]
                      }
                    },
                    fields: {
                      newMessage: {
                        type: "Message",
                        id: 1
                      }
                    }
                  }
                }
              }
            }
          },
          PutMessageRequest: {
            fields: {
              bodyType: {
                type: "bytes",
                id: 5
              }
            }
          },
          PutMessageResponse: {
            fields: {}
          },
          PutMessageError: {
            fields: {
              code: {
                type: "Code",
                id: 1
              },
              userMessage: {
                type: "string",
                id: 2
              }
            },
            nested: {
              Code: {
                values: {
                  UNKNOWN: 0
                }
              }
            }
          }
        }
      }
    }
  }
});

module.exports = $root;


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return modals; });
var modals = {
  confirm_lock_conference: {
    title: 'Lock Conference',
    description: 'Locking a conference will prevent new participants from joining. You can only lock conference when you are in it.'
  },
  confirm_mute_all: {
    title: 'Mute Everyone',
    description: 'Everyone will be notified that they have been muted. Callers can un-mute themselves by tapping Un-mute button. You can un-mute participants individually at any time.'
  },
  confirm_muted_by_admin: {
    title: 'You were muted by admin',
    description: 'You can un-mute yourself by tapping Un-mute button.'
  },
  prompt_conference_ended: {
    title: 'Conference ended',
    description: 'You have been disconnected from a call.'
  },
  prompt_conference_kicked: {
    title: 'You were kicked by admin',
    description: 'You can always re-join to conference.'
  },
  prompt_join_error_incorrect_credentials: {
    title: 'Incorrect ID or PIN',
    description: 'You can’t join this conference because ID or PIN is incorrect. Please contact an administrator.'
  },
  prompt_join_error_room_locked: {
    title: 'Conference is locked',
    description: 'You can’t join this conference because it has been locked. Please contact an administrator.'
  },
  prompt_join_error_room_full: {
    title: 'Conference is full',
    description: 'You can’t join this conference because it has reached its maximum capacity. Please contact an administrator.'
  },
  prompt_join_error_unknown: {
    title: 'Ops!',
    description: 'Unknown error'
  }
};

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blob_to_buffer__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blob_to_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_blob_to_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_proto_bundle__);






var CallBuider = function () {
  function CallBuider() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CallBuider);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CallBuider, [{
    key: 'createCreateSlotRequestBody',
    value: function createCreateSlotRequestBody(c) {
      var builder = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('CreateSlotRequest');
      var payload = builder.create({
        username: c.username,
        pin: c.pin
      });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'createPingBody',
    value: function createPingBody() {
      var builder = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('ConnectRequests');
      var payload = builder.create({
        ping: 0
      });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'createSessionDescriptionBody',
    value: function createSessionDescriptionBody(data, sequence) {
      var connectRequests = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('ConnectRequests');
      var dataMessage = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('DataMessage');
      var payload = connectRequests.create({
        webrtcMessage: {
          sequence: sequence,
          data: dataMessage.create({
            sessionsDescription: {
              type: 1,
              description: data.sdp
            }
          })
        }
      });
      return connectRequests.encode(payload).finish();
    }
  }, {
    key: 'createIceCandidateBody',
    value: function createIceCandidateBody(sdp, sequence) {
      var connectRequests = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('ConnectRequests');
      var dataMessage = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('DataMessage');
      var payload = connectRequests.create({
        webrtcMessage: {
          sequence: sequence,
          data: dataMessage.create({
            iceCandidateAdd: {
              iceCandidate: [{
                sdpMid: sdp.sdpMid,
                sdpMLineIndex: sdp.sdpMLineIndex,
                sdp: sdp.candidate
              }]
            }
          })
        }
      });
      return connectRequests.encode(payload).finish();
    }
  }, {
    key: 'createMuteRequestBody',
    value: function createMuteRequestBody(val) {
      var builder = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('MuteRequest');
      var payload = builder.create({
        mute: val
      });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'createLockRequestBody',
    value: function createLockRequestBody(val) {
      var builder = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('LockRequest');
      var payload = builder.create({
        lock: val
      });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'createEndSlotRequest',
    value: function createEndSlotRequest() {
      var builder = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('EndSlotRequest');
      var payload = builder.create({
        reason: 1,
        clientMessage: 'user wished to leave the conference'
      });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'createTitleRequestBody',
    value: function createTitleRequestBody(title) {
      var builder = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('TitleRequest');
      var payload = builder.create({ title: title });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'createMuteUserRequestBody',
    value: function createMuteUserRequestBody(userId) {
      var builder = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('MuteUserRequest');
      var payload = builder.create({ userId: userId });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'createUnmuteUserRequestBody',
    value: function createUnmuteUserRequestBody(userId) {
      var builder = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('UnmuteUserRequest');
      var payload = builder.create({ userId: userId });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'createKickUserRequestBody',
    value: function createKickUserRequestBody(userId) {
      var builder = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('KickUserRequest');
      var payload = builder.create({ userId: userId });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'createPutAdminRequestBody',
    value: function createPutAdminRequestBody(isAdmin) {
      var builder = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('PutAdminRequest');
      var payload = builder.create({ isAdmin: isAdmin });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'decodeCreateSlotResponse',
    value: function decodeCreateSlotResponse(payload) {
      var container = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('CreateSlotResponse');
      return container.decode(new Uint8Array(payload));
    }
  }, {
    key: 'decodeCreateSlotError',
    value: function decodeCreateSlotError(payload) {
      var container = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('CreateSlotError');
      return container.decode(new Uint8Array(payload));
    }
  }, {
    key: 'decodeConnectResponses',
    value: function decodeConnectResponses(payload) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3_blob_to_buffer___default()(payload, function (err, buffer) {
          var container = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('ConnectResponses');
          var message = container.decode(new Uint8Array(buffer));
          resolve(message);
        });
      });
    }
  }, {
    key: 'decodePhoenix',
    value: function decodePhoenix(payload, callback) {
      __WEBPACK_IMPORTED_MODULE_3_blob_to_buffer___default()(payload, function (err, buffer) {
        var container = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('CallChannel');
        var message = container.decode(new Uint8Array(buffer));
        console.info('phoenix', message);
        callback(message.toJSON());
      });
    }
  }, {
    key: 'decodeCallChannel',
    value: function decodeCallChannel(payload, callback) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_blob_to_buffer___default()(payload, function (err, buffer) {
        var container = __WEBPACK_IMPORTED_MODULE_4__static_proto_bundle___default.a.lookup('CallChannel');
        var message = container.decode(new Uint8Array(buffer));
        var normalized = _this.adjustToPhoenixProtocol(message.toJSON());
        if (normalized.payload.participantsCount && normalized.payload.participantsCount.update) {
          if (callback) {
            callback(normalized.payload.participantsCount.update);
          }
        }
      });
    }
  }, {
    key: 'adjustToPhoenixProtocol',
    value: function adjustToPhoenixProtocol(message) {
      if (message.event === 'phx_reply' && message.replyStatus) {
        if (!message.payload) {
          message.payload = {};
        }
        message.payload.status = message.replyStatus;
      }

      if (message.event === 'phx_close') {
        message.payload = {
          status: 'ok'
        };
      }

      return message;
    }
  }]);

  return CallBuider;
}();

/* harmony default export */ __webpack_exports__["a"] = (CallBuider);

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.855ed5b.png";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(443),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-701d8e65",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(436),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33939363",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(446),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bceea26e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(431),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-155d6749",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var scrollToBottom = function scrollToBottom(el) {
  el.scrollTop = el.scrollHeight;
};

var chantScroll = {
  bind: function bind(el, binding) {
    var timeout = void 0;
    var scrolled = false;

    el.addEventListener('scroll', function (e) {
      if (timeout) window.clearTimeout(timeout);
      timeout = window.setTimeout(function () {
        scrolled = el.scrollTop + el.clientHeight + 1 < el.scrollHeight;
      }, 200);
    });

    new MutationObserver(function (e) {
      var config = binding.value || {};
      var pause = config.always === false && scrolled;
      if (pause || e[e.length - 1].addedNodes.length !== 1) return;
      scrollToBottom(el);
    }).observe(el, { childList: true });
  },
  inserted: scrollToBottom
};

/* harmony default export */ __webpack_exports__["a"] = (chantScroll);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var fallbackSrc = {
  bind: function bind(el, binding) {
    var handler = function handler(e) {
      el.src = binding.value;
      el.removeEventListener('error', handler);
    };
    el.addEventListener('error', handler);
  },

  inserted: function inserted(el, binding, vnode) {
    el.style.backgroundImage = 'url(\'' + binding.value + '\')';
  }
};

/* harmony default export */ __webpack_exports__["a"] = (fallbackSrc);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var focus = {
  inserted: function inserted(el) {
    el.focus();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (focus);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = preventParentScroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);

var map = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();

function preventParentScroll(Vue) {
  Vue.directive('prevent-parent-scroll', {
    bind: function bind(el) {
      var handler = function handler(event) {
        if ((el.scrollTop === 0 && event.deltaY) < 0 || Math.abs(el.scrollTop - (el.scrollHeight - el.clientHeight)) <= (1 && event.deltaY > 0)) {
          event.preventDefault();
        }
      };
      map.set(el, handler);
      el.addEventListener('wheel', handler);
    },
    unbind: function unbind(el) {
      el.removeEventListener('wheel', map.get(el));
      map.delete(el);
    }
  });
}

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__websockets_websocket_connection__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conference_conference__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_user__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chat_chat__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__broadcast_broadcast__ = __webpack_require__(264);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    socketConnection: __WEBPACK_IMPORTED_MODULE_2__websockets_websocket_connection__["a" /* default */],
    conference: __WEBPACK_IMPORTED_MODULE_3__conference_conference__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_4__user_user__["a" /* default */],
    chat: __WEBPACK_IMPORTED_MODULE_5__chat_chat__["a" /* default */],
    broadcast: __WEBPACK_IMPORTED_MODULE_6__broadcast_broadcast__["a" /* default */]
  }
}));

/***/ }),
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(361)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(440),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_modal__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_filters__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_moment__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_on_click_outside__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_prevent_parent_scroll_directive__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_focus_directive__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_chat_scroll_directive__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_fallback_src_directive__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants_remote_paths_constant__ = __webpack_require__(12);





















if (true) {
  __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.config('https://e5c9513e774a45608b1140b7c7de3a99@sentry.appunite.com/21').addPlugin(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('on-click-outside', __WEBPACK_IMPORTED_MODULE_11_vue_on_click_outside__["directive"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('focus', __WEBPACK_IMPORTED_MODULE_13__directives_focus_directive__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('chat-scroll', __WEBPACK_IMPORTED_MODULE_14__directives_chat_scroll_directive__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('fallback-src', __WEBPACK_IMPORTED_MODULE_15__directives_fallback_src_directive__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12__directives_prevent_parent_scroll_directive__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_9_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('infinite-loading', __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (req, next) {
  next(function (res) {
    if (!res.ok && res.status === 401) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$cookie.delete('accessToken');
      window.location.href = '' + __WEBPACK_IMPORTED_MODULE_19__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].AUTH_PATH + window.location.pathname;
    }
    return res;
  });
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_17__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_16__app___default.a }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_proto_bundle__);




var BroadcastBuider = function () {
  function BroadcastBuider() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BroadcastBuider);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BroadcastBuider, [{
    key: 'createStartBroadcastRequest',
    value: function createStartBroadcastRequest(stream) {
      var builder = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup('StartBroadcastRequest');
      var streamBuilder = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup('BroadcastStream');
      var streamPayload = streamBuilder.create(stream);
      var payload = builder.create({ stream: streamPayload });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'decode',
    value: function decode(payload, message) {
      var container = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup(message);
      return container.decode(new Uint8Array(payload));
    }
  }]);

  return BroadcastBuider;
}();

/* harmony default export */ __webpack_exports__["a"] = (BroadcastBuider);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blob_to_buffer__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blob_to_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_blob_to_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_proto_bundle__);





var ChatBuider = function () {
  function ChatBuider() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ChatBuider);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ChatBuider, [{
    key: 'createTextMessageBody',
    value: function createTextMessageBody(text, userId) {
      var builder = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('PutMessageRequest');
      var BodyTypes = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('BodyTypes');
      var Text = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('BodyTypes.Text');
      var now = new Date().getTime();
      var id = this.generateUUID();

      var bodyType = BodyTypes.create({
        text: Text.create({
          body: text
        })
      });

      var payload = builder.create({
        message: {
          messageId: id,
          createdAtMillis: now,
          creatorId: userId,
          deleted: false,
          bodyType: BodyTypes.encode(bodyType).finish()
        }
      });

      return builder.encode(payload).finish();
    }
  }, {
    key: 'createPingMessageBody',
    value: function createPingMessageBody(userId) {
      var builder = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('PutMessageRequest');
      var BodyTypes = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('BodyTypes');
      var Ping = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('BodyTypes.Ping');
      var now = new Date().getTime();
      var id = this.generateUUID();

      var bodyType = BodyTypes.create({
        ping: Ping.create({
          ping: 1
        })
      });

      var payload = builder.create({
        message: {
          messageId: id,
          createdAtMillis: now,
          creatorId: userId,
          deleted: false,
          bodyType: BodyTypes.encode(bodyType).finish()
        }
      });

      return builder.encode(payload).finish();
    }
  }, {
    key: 'createImageMessageBody',
    value: function createImageMessageBody(data, userId) {
      var builder = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('PutMessageRequest');
      var BodyTypes = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('BodyTypes');
      var Image = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('BodyTypes.Image');
      var now = new Date().getTime();
      var id = this.generateUUID();

      var bodyType = BodyTypes.create({
        image: Image.create(data)
      });

      var payload = builder.create({
        message: {
          messageId: id,
          createdAtMillis: now,
          creatorId: userId,
          deleted: false,
          bodyType: BodyTypes.encode(bodyType).finish()
        }
      });

      return builder.encode(payload).finish();
    }
  }, {
    key: 'createRpcSendMessageClientRequestBody',
    value: function createRpcSendMessageClientRequestBody(text) {
      var builder = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('RpcSendMessageClientRequest');
      var BodyTypes = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('BodyTypes');
      var Text = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('BodyTypes.Text');
      var bodyType = BodyTypes.create({
        text: Text.create({
          body: text
        })
      });
      var payload = builder.create({
        body: bodyType
      });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'decodePutMessageResponse',
    value: function decodePutMessageResponse(payload) {
      var container = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('PutMessageResponse');
      var bodyTypes = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('BodyTypes');
      var message = container.decode(new Uint8Array(payload));
      message.message.bodyType = bodyTypes.decode(new Uint8Array(message.message.bodyType));
      return message;
    }
  }, {
    key: 'decodeChatResponse',
    value: function decodeChatResponse(payload) {
      var _this = this;

      var container = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('ChatResponse');
      var message = container.decode(new Uint8Array(payload));
      message.messages.forEach(function (msg) {
        msg.bodyType = _this.decodeBodyTypes(msg.bodyType);
      });
      return message;
    }
  }, {
    key: 'decodeBodyTypes',
    value: function decodeBodyTypes(payload) {
      var bodyTypes = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('BodyTypes');
      return bodyTypes.decode(new Uint8Array(payload));
    }
  }, {
    key: 'decodeChatChannel',
    value: function decodeChatChannel(payload, callback) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_blob_to_buffer___default()(payload, function (err, buffer) {
        var container = __WEBPACK_IMPORTED_MODULE_3__static_proto_bundle___default.a.lookup('ChatChannel');
        var message = container.decode(new Uint8Array(buffer));
        var normalized = _this2.adjustToPhoenixProtocol(message.toJSON());
        if (normalized.payload.chat && normalized.payload.chat.newMessage) {
          var decodedMessage = message.payload.chat.newMessage;
          decodedMessage.bodyType = _this2.decodeBodyTypes(message.payload.chat.newMessage.bodyType);
          if (callback) {
            callback(decodedMessage);
          }
        }
      });
    }
  }, {
    key: 'adjustToPhoenixProtocol',
    value: function adjustToPhoenixProtocol(message) {
      if (message.event === 'phx_reply' && message.replyStatus) {
        if (!message.payload) {
          message.payload = {};
        }
        message.payload.status = message.replyStatus;
      }

      if (message.event === 'phx_close') {
        message.payload = {
          status: 'ok'
        };
      }

      return message;
    }
  }, {
    key: 'generateUUID',
    value: function generateUUID() {
      var s4 = function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      };
      return '' + s4() + s4() + s4() + s4();
    }
  }]);

  return ChatBuider;
}();

/* harmony default export */ __webpack_exports__["a"] = (ChatBuider);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var PlaySounds = function () {
  function PlaySounds() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PlaySounds);

    this.tracks = {};
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PlaySounds, [{
    key: "play",
    value: function play(name, repeat) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (_this.audio) {
          _this.audio.pause();
          _this.audio.currentTime = 0;
          _this.audio = null;
        }
        if (!_this.tracks[name]) {
          _this.tracks[name] = __webpack_require__(453)("./" + name + ".mp3");
        }
        _this.audio = new Audio(_this.tracks[name]);
        _this.audio.play();
        _this.audio.onended = function () {
          if (repeat && _this.audio) {
            _this.audio.currentTime = 0;
            _this.audio.play();
          }
          resolve();
        };
      });
    }
  }]);

  return PlaySounds;
}();

/* harmony default export */ __webpack_exports__["a"] = (PlaySounds);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_proto_bundle__);




var UserBuider = function () {
  function UserBuider() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UserBuider);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UserBuider, [{
    key: 'createPutUsernameRequestBody',
    value: function createPutUsernameRequestBody(username) {
      var builder = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup('PutUsernameRequest');
      var payload = builder.create({
        username: username
      });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'createPutConferencePinRequestBody',
    value: function createPutConferencePinRequestBody(pin) {
      var builder = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup('PutConferencePinRequest');
      var payload = builder.create({
        conferencePin: pin
      });
      return builder.encode(payload).finish();
    }
  }, {
    key: 'decodePutConferencePinResponse',
    value: function decodePutConferencePinResponse(payload) {
      var container = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup('PutConferencePinResponse');
      return container.decode(new Uint8Array(payload));
    }
  }, {
    key: 'decodePutUsernameResponse',
    value: function decodePutUsernameResponse(payload) {
      var container = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup('PutUsernameResponse');
      return container.decode(new Uint8Array(payload));
    }
  }, {
    key: 'decodeCurrentUserResponse',
    value: function decodeCurrentUserResponse(payload) {
      var container = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup('CurrentUserResponse');
      return container.decode(new Uint8Array(payload));
    }
  }, {
    key: 'decodeHistoryResponse',
    value: function decodeHistoryResponse(payload) {
      var container = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup('HistoryResponse');
      return container.decode(new Uint8Array(payload));
    }
  }, {
    key: 'decodeContactsResponse',
    value: function decodeContactsResponse(payload) {
      var container = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup('ContactsResponse');
      return container.decode(new Uint8Array(payload));
    }
  }, {
    key: 'decodeUserResponse',
    value: function decodeUserResponse(payload) {
      var container = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup('UserResponse');
      return container.decode(new Uint8Array(payload));
    }
  }, {
    key: 'decodeBuyResponse',
    value: function decodeBuyResponse(payload) {
      var container = __WEBPACK_IMPORTED_MODULE_2__static_proto_bundle___default.a.lookup('BuyResponse');
      return container.decode(new Uint8Array(payload));
    }
  }]);

  return UserBuider;
}();

/* harmony default export */ __webpack_exports__["a"] = (UserBuider);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_broadcast_builder_service__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(15);





var state = {
  BroadcastBuider: new __WEBPACK_IMPORTED_MODULE_2__services_broadcast_builder_service__["a" /* default */]()
};

var getters = {};

var actions = {
  startBroadcast: function startBroadcast(_ref, url) {
    var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch;

    var body = state.BroadcastBuider.createStartBroadcastRequest({
      broadcastType: 1,
      broadcastUrl: url
    });
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].startBroadcast(body).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
          name: 'BroadcastingTab',
          params: { rstp: encodeURI(url) }
        });
        resolve();
      });
    });
  },
  stopBroadcast: function stopBroadcast(_ref2) {
    var state = _ref2.state,
        commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].stopBroadcast().then(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        name: 'MainMenu'
      });
    });
  },
  checkBroadcastingStatus: function checkBroadcastingStatus(_ref3) {
    var state = _ref3.state,
        commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].checkBroadcastingStatus().then(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        name: 'BroadcastingTab'
      });
    }, function () {
      console.info('Broadcasting was not started');
    });
  }
};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_chat_builder_service__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_modals_constant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_remote_paths_constant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_phoenix__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_phoenix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_phoenix__);








var state = {
  chatBuilder: new __WEBPACK_IMPORTED_MODULE_2__services_chat_builder_service__["a" /* default */](),
  messages: [],
  nextToken: '',
  chatChannelName: null,
  phoenixSocket: null,
  channel: null,
  unreadMessagesCount: 0
};

var getters = {
  messages: function messages(state) {
    return state.messages;
  },
  messagesEnded: function messagesEnded(state) {
    return !state.nextToken || state.nextToken === '';
  },
  unreadMessagesCount: function unreadMessagesCount(state) {
    var count = state.unreadMessagesCount > 99 ? '99+' : state.unreadMessagesCount;
    return count || false;
  }
};

var actions = {
  joinChat: function joinChat(_ref, name) {
    var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('setChatChannelName', name);
    dispatch('connectChatSocket');
    dispatch('getChatMessages');
  },
  sendChatMessage: function sendChatMessage(_ref2, _ref3) {
    var state = _ref2.state,
        commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        rootState = _ref2.rootState;
    var type = _ref3.type,
        data = _ref3.data;

    var body = void 0;
    switch (type) {
      case 'text':
        body = state.chatBuilder.createTextMessageBody(data, rootState.conference.user.userId);
        break;
      case 'ping':
        body = state.chatBuilder.createPingMessageBody(rootState.conference.user.userId);
        break;
      case 'image':
        body = state.chatBuilder.createImageMessageBody(data, rootState.conference.user.userId);
        break;
      default:
        break;

    }
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].sendChatMessage(body, state.chatChannelName).then(function (payload) {
      var decoded = state.chatBuilder.decodePutMessageResponse(payload.data);
    });
  },
  sendChatImage: function sendChatImage(_ref4, _ref5) {
    var state = _ref4.state,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch;
    var file = _ref5.file,
        onprogress = _ref5.onprogress;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].uploadImage(file, onprogress).then(function (response) {
        var w = Math.floor(Math.random() * 1879 + 50);
        var h = Math.floor(Math.random() * 1879 + 50);
        dispatch('sendChatMessage', {
          type: 'image',
          data: {
            imageUrl: 'http://via.placeholder.com/' + w + 'x' + h,
            imageWidth: w,
            imageHeight: h
          }
        });
        resolve();
      });
    });
  },
  getChatMessages: function getChatMessages(_ref6) {
    var state = _ref6.state,
        commit = _ref6.commit,
        dispatch = _ref6.dispatch,
        rootState = _ref6.rootState;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var params = {
        limit: 20,
        next_token: state.nextToken
      };
      if (state.nextToken === '') {
        state.messages = [];
      }
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getChatMessages(state.chatChannelName, params).then(function (payload) {
        var decoded = state.chatBuilder.decodeChatResponse(payload.data);
        state.messages = state.messages.concat(decoded.messages);
        state.nextToken = decoded.nextToken;
        if (!rootState.conference.aside) {
          state.unreadMessagesCount += decoded.messages.length;
        }
        resolve(!decoded.nextToken);
      });
    });
  },
  sendInviteMessages: function sendInviteMessages(_ref7, _ref8) {
    var state = _ref7.state,
        commit = _ref7.commit,
        dispatch = _ref7.dispatch;
    var users = _ref8.users,
        url = _ref8.url,
        username = _ref8.username,
        pin = _ref8.pin;

    dispatch('toggleAside', 'invite-menu');
    var body = state.chatBuilder.createRpcSendMessageClientRequestBody('You\'ve been invited to @' + username + '\'s conference call that starts now. Join using this KingsConference URL: ' + url + ' or by inputting the following in the KingsConference app Username: ' + username + ' and PIN: ' + pin);
    users.forEach(function (id) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].inviteUser(id, body);
    });
  },
  connectChatSocket: function connectChatSocket(_ref9) {
    var state = _ref9.state,
        commit = _ref9.commit,
        dispatch = _ref9.dispatch,
        rootState = _ref9.rootState;

    var socketParams = {
      decode: function decode(payload, callback) {
        state.chatBuilder.decodeChatChannel(payload, callback);
      },
      params: {
        authorization: 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$cookie.get('accessToken')
      }
    };
    state.phoenixSocket = new __WEBPACK_IMPORTED_MODULE_6_phoenix__["Socket"](__WEBPACK_IMPORTED_MODULE_5__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].WS_PATH + '/conference/chat_channel', socketParams);
    state.phoenixSocket.onConnMessage = function (response) {
      state.chatBuilder.decodeChatChannel(response.data, function (message) {
        state.messages.unshift(message);
        if (!rootState.conference.aside) {
          state.unreadMessagesCount += 1;
        }
      });
    };
    if (true) {
      state.phoenixSocket.connect();
    }
    state.channel = state.phoenixSocket.channel(state.chatChannelName, {});
    state.channel.join().receive('ok', function (_ref10) {
      var messages = _ref10.messages;
      return console.log('catching up', messages);
    }).receive('error', function (_ref11) {
      var reason = _ref11.reason;
      return console.log('failed join', reason);
    }).receive('timeout', function () {
      return console.log('Networking issue. Still waiting...');
    });
    state.channel.on('chat', function (message) {
      console.info('on chat', message);
    });
    state.channel.on('first_response', function (message) {
      console.info('on first_response', message);
    });
    state.channel.on('new_message', function (message) {
      console.info('on new_message', message);
    });
    state.channel.on('chat', function (message) {
      console.info('on chat', message);
    });
  },
  disconnectChat: function disconnectChat(_ref12) {
    var state = _ref12.state,
        commit = _ref12.commit,
        dispatch = _ref12.dispatch;

    if (state.phoenixSocket) {
      state.phoenixSocket.disconnect();
    }
    commit('clearChatData');
  }
};

var mutations = {
  setChatChannelName: function setChatChannelName(state, name) {
    state.chatChannelName = name;
  },
  clearChatData: function clearChatData(state) {
    state.chatChannelName = null;
    state.messages = [];
    state.nextToken = '';
    state.phoenixSocket = null;
    state.channel = null;
  },
  resetUnreadMessagesCount: function resetUnreadMessagesCount(state) {
    state.unreadMessagesCount = 0;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_call_builder_service__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_play_sounds_service__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_modals_constant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_remote_paths_constant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_phoenix__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_phoenix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_phoenix__);












var state = {
  slot: null,
  status: null,
  credentials: null,
  peerConnection: null,
  owner: null,
  user: null,
  localStream: null,
  remoteStream: null,
  initializing: true,
  devices: {},
  currentInput: localStorage.getItem('default-audio-input') || 'default',
  currentOutput: localStorage.getItem('default-audio-output') || 'default',
  conferenceBuilder: new __WEBPACK_IMPORTED_MODULE_4__services_call_builder_service__["a" /* default */](),
  startedAt: null,
  aside: null,
  recentConferences: null,
  ownerIsPresent: null,
  participantsCount: 0,
  callChannelSocket: null,
  messagesSent: [],
  sequence: 1,
  playSounds: new __WEBPACK_IMPORTED_MODULE_5__services_play_sounds_service__["a" /* default */](),
  currentRoomParticipantsCount: null,
  broadcast: null
};

var getters = {
  participantsCount: function participantsCount(state) {
    return state.participantsCount;
  },
  ownerIsPresent: function ownerIsPresent(state) {
    return state.ownerIsPresent;
  },
  aside: function aside(state) {
    return state.aside;
  },
  conference: function conference(state) {
    return {
      status: state.status,
      credentials: state.credentials
    };
  },
  user: function user(state) {
    return state.user || {};
  },
  owner: function owner(state) {
    return state.owner || {};
  },
  initializing: function initializing(state) {
    return state.initializing;
  },
  devices: function devices(state) {
    var devices = {
      input: [],
      output: []
    };
    if (state.devices.length) {
      state.devices.forEach(function (_ref) {
        var label = _ref.label,
            deviceId = _ref.deviceId,
            kind = _ref.kind;

        if (kind === 'audioinput') {
          var device = { label: label, deviceId: deviceId };
          devices.input.push(device);
          if (deviceId === state.currentInput) {
            devices.selectedInput = device;
          }
        }
        if (kind === 'audiooutput') {
          var _device = { label: label, deviceId: deviceId };
          devices.output.push(_device);
          if (deviceId === state.currentOutput) {
            devices.selectedOutput = _device;
          }
        }
      });
    }
    return devices;
  },
  localStream: function localStream(state) {
    return state.localStream;
  },
  localStreamSrc: function localStreamSrc(state) {
    return state.localStream;
  },
  remoteStreamSrc: function remoteStreamSrc(state) {
    return state.remoteStream;
  },
  startedAt: function startedAt(state) {
    return state.startedAt;
  },
  broadcast: function broadcast(state) {
    return state.broadcast || {};
  }
};

var actions = {
  joinRoom: function joinRoom(_ref2, _ref3) {
    var state = _ref2.state,
        commit = _ref2.commit,
        dispatch = _ref2.dispatch;
    var pin = _ref3.pin,
        username = _ref3.username;

    state.playSounds.play('call_connecting');
    state.credentials = {
      conferenceUrl: window.location.href,
      conferencePin: pin,
      username: username
    };

    var buffer = state.conferenceBuilder.createCreateSlotRequestBody({ pin: pin, username: username });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].createSlot(buffer).then(function (response) {
      state.slot = state.conferenceBuilder.decodeCreateSlotResponse(response.body);
      state.slot.iceServers.forEach(function (iceServer) {
        iceServer.urls = iceServer.uri;
        iceServer.credential = iceServer.password;
      });
      dispatch('connectWebsocket', state.slot.slotId);
    }, function (err) {
      dispatch('handleCreateSlotError', err);
    });
  },
  setPeerConnection: function setPeerConnection(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        rootState = _ref4.rootState;

    state.startedAt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
    dispatch('startStream');
    dispatch('joinChat', state.slot.chatChannelName);
  },
  startStream: function startStream(_ref5, deviceId) {
    var state = _ref5.state,
        commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

      if (deviceId) {
        state.currentInput = deviceId;
      }

      var audio = true;
      if (state.currentInput) {
        audio = {
          optional: [{
            sourceId: state.currentInput
          }]
        };
      }

      getUserMedia.call(navigator, { audio: true, video: false }, function (stream) {
        dispatch('gotStream', stream);
        resolve(stream);
      }, function (error) {});
    });
  },
  gotStream: function gotStream(_ref6, stream) {
    var state = _ref6.state,
        commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    state.localStream = stream;
    var PeerConnection = window.webkitPeerConnection00 || window.webkitRTCPeerConnection || window.mozRTCPeerConnection || window.RTCPeerConnection || window.PeerConnection;

    state.peerConnection = new PeerConnection({ iceServers: state.slot.iceServers }, { optional: [{ DtlsSrtpKeyAgreement: true }] });

    state.peerConnection.onicecandidate = function (event) {
      return dispatch('gotIceCandidate', event);
    };
    state.peerConnection.onaddstream = function (event) {
      return dispatch('gotRemoteStream', event);
    };
    state.peerConnection.addStream(state.localStream);

    state.peerConnection.createOffer(function (desc) {
      return dispatch('gotDescription', desc);
    }, function (err) {
      return console.warn(err);
    }, { mandatory: { OfferToReceiveAudio: true } });
  },
  gotDescription: function gotDescription(_ref7, desc) {
    var state = _ref7.state,
        commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    state.peerConnection.setLocalDescription(desc);
    var body = state.conferenceBuilder.createSessionDescriptionBody(desc, state.sequence);
    dispatch('sendSocketMessage', body);
    commit('keepSequence', body);
  },
  gotIceCandidate: function gotIceCandidate(_ref8, event) {
    var state = _ref8.state,
        commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    if (event.candidate) {
      var body = state.conferenceBuilder.createIceCandidateBody(event.candidate, state.sequence);
      dispatch('sendSocketMessage', body);
      commit('keepSequence', body);
    }
  },
  setRemoteDescription: function setRemoteDescription(_ref9, _ref10) {
    var state = _ref9.state;
    var type = _ref10.type,
        description = _ref10.description;

    var types = ['unknown', 'offer', 'pranswer', 'answer'];
    state.peerConnection.setRemoteDescription(new RTCSessionDescription({
      type: types[type],
      sdp: description
    }));
  },
  gotRemoteStream: function gotRemoteStream(_ref11, event) {
    var state = _ref11.state,
        dispatch = _ref11.dispatch;

    // document.getElementById('remoteStream').srcObject = event.stream;
    state.remoteStream = event.stream;
    if (state.currentOutput) {
      dispatch('attachSinkId', state.currentOutput);
    }
  },
  muteCall: function muteCall(_ref12) {
    var state = _ref12.state;

    var body = state.conferenceBuilder.createMuteRequestBody(!state.user.isMuted);
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].muteCall(body, state.slot.slotId);
  },
  lockCall: function lockCall(_ref13) {
    var state = _ref13.state;

    var id = 'confirm_lock_conference';
    var body = state.conferenceBuilder.createLockRequestBody(!state.status.locked);
    if (!localStorage.getItem(id) && !state.status.locked) {
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$modal.show('confirmation-modal', {
        id: id,
        title: __WEBPACK_IMPORTED_MODULE_8__constants_modals_constant__["a" /* modals */][id].title,
        description: __WEBPACK_IMPORTED_MODULE_8__constants_modals_constant__["a" /* modals */][id].description,
        rememberOption: true,
        actions: [{
          label: 'cancel',
          class: 'cancel-btn'
        }, {
          label: 'lock',
          class: 'submit-btn',
          handler: function handler() {
            __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].lockCall(body, state.slot.slotId);
          }
        }]
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].lockCall(body, state.slot.slotId);
    }
  },
  muteAll: function muteAll(_ref14) {
    var state = _ref14.state;

    var id = 'confirm_mute_all';
    if (!localStorage.getItem(id) && !state.status.locked) {
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$modal.show('confirmation-modal', {
        id: id,
        title: __WEBPACK_IMPORTED_MODULE_8__constants_modals_constant__["a" /* modals */][id].title,
        description: __WEBPACK_IMPORTED_MODULE_8__constants_modals_constant__["a" /* modals */][id].description,
        rememberOption: true,
        actions: [{
          label: 'cancel',
          class: 'cancel-btn'
        }, {
          label: 'mute all',
          class: 'submit-btn',
          handler: function handler() {
            state.playSounds.play('call_mute');
            __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].muteAll(state.slot.slotId).then(function () {
              state.playSounds.play('call_muted');
            });
          }
        }]
      });
    } else {
      state.playSounds.play('call_mute');
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].muteAll(state.slot.slotId).then(function () {
        state.playSounds.play('call_muted');
      });
    }
  },
  endCall: function endCall(_ref15) {
    var state = _ref15.state;

    if (state.user.isOwner) {
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].endCall();
    } else {
      var body = state.conferenceBuilder.createEndSlotRequest();
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].leaveCall(state.slot.slotId, body);
    }
  },
  mutedByAdmin: function mutedByAdmin(_ref16, _ref17) {
    var state = _ref16.state,
        commit = _ref16.commit;
    var whoUserId = _ref17.whoUserId;

    if (state.user.userId !== whoUserId) {
      var id = 'confirm_muted_by_admin';
      if (!localStorage.getItem(id)) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$modal.show('confirmation-modal', {
          id: id,
          title: __WEBPACK_IMPORTED_MODULE_8__constants_modals_constant__["a" /* modals */][id].title,
          description: __WEBPACK_IMPORTED_MODULE_8__constants_modals_constant__["a" /* modals */][id].description,
          rememberOption: true,
          actions: [{
            label: 'ok, got it',
            class: 'submit-btn'
          }]
        });
      }
    }
  },
  closeConference: function closeConference(_ref18, code) {
    var state = _ref18.state,
        commit = _ref18.commit;

    // code 1 - ended by admin; 2 - kicked by admin
    if (code === 1 && !state.user.isOwner || code === 2) {
      var id = 'prompt_conference_' + (code === 1 ? 'ended' : 'kicked');
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$modal.show('confirmation-modal', {
        id: id,
        title: __WEBPACK_IMPORTED_MODULE_8__constants_modals_constant__["a" /* modals */][id].title,
        description: __WEBPACK_IMPORTED_MODULE_8__constants_modals_constant__["a" /* modals */][id].description,
        rememberOption: code === 2,
        actions: [{
          label: 'ok, got it',
          class: 'submit-btn'
        }]
      });
    }
    if (state.peerConnection) {
      state.peerConnection.close();
    }
    if (state.localStream && state.localStream.getTracks()[0]) {
      state.localStream.getTracks()[0].stop();
    }
    state.playSounds.play('call_ended');
    commit('clearConferenceState');
    __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push('/');
  },
  attachSinkId: function attachSinkId(_ref19, sinkId) {
    var state = _ref19.state;

    var element = document.getElementById('remoteStream');
    if (sinkId && element && typeof element.sinkId !== 'undefined') {
      element.setSinkId(sinkId).then(function () {
        if (state.currentOutput !== sinkId) {
          state.currentOutput = sinkId;
        }
      });
    }
  },
  setDefaultDevices: function setDefaultDevices(_ref20) {
    var state = _ref20.state,
        dispatch = _ref20.dispatch;

    state.currentInput = localStorage.getItem('default-audio-input') || 'default';
    state.currentOutput = localStorage.getItem('default-audio-output') || 'default';
    dispatch('attachSinkId', state.currentOutput);
    dispatch('startStream');
  },
  setConferenceTitle: function setConferenceTitle(_ref21, title) {
    var state = _ref21.state;

    var body = state.conferenceBuilder.createTitleRequestBody(title);
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].setTitle(body, state.slot.slotId);
  },
  muteUser: function muteUser(_ref22, userId) {
    var state = _ref22.state;

    var body = state.conferenceBuilder.createMuteUserRequestBody(userId);
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].muteUser(body, state.slot.slotId);
  },
  unmuteUser: function unmuteUser(_ref23, userId) {
    var state = _ref23.state;

    var body = state.conferenceBuilder.createUnmuteUserRequestBody(userId);
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].unmuteUser(body, state.slot.slotId);
  },
  kickUser: function kickUser(_ref24, userId) {
    var state = _ref24.state;

    var body = state.conferenceBuilder.createKickUserRequestBody(userId);
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].kickUser(body, state.slot.slotId);
  },
  putAdminRights: function putAdminRights(_ref25, _ref26) {
    var state = _ref25.state;
    var userId = _ref26.userId,
        isAdmin = _ref26.isAdmin;

    var body = state.conferenceBuilder.createPutAdminRequestBody(isAdmin);
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].putAdminRights(body, state.slot.slotId, userId);
  },
  toggleAside: function toggleAside(_ref27, type) {
    var state = _ref27.state,
        commit = _ref27.commit;

    if (state.aside === type) {
      state.aside = false;
    } else {
      var timeout = state.aside ? 300 : 0;
      state.aside = false;
      setTimeout(function () {
        state.aside = type;
        if (type === 'chat') {
          commit('resetUnreadMessagesCount');
        }
      }, timeout);
    }
  },
  updateConference: function updateConference(_ref28, _ref29) {
    var state = _ref28.state,
        commit = _ref28.commit,
        dispatch = _ref28.dispatch,
        rootState = _ref28.rootState;
    var updateStatus = _ref29.updateStatus,
        updateCredentials = _ref29.updateCredentials;

    state.user = rootState.user.currentUser;
    if (updateStatus) {
      var ownerIsPresent = false;
      updateStatus.participants.forEach(function (user) {
        if (user.userId === updateStatus.ownerUserId) {
          ownerIsPresent = true;
        }
        if (state.user && user.userId === state.user.userId) {
          state.user.isAdmin = user.isAdmin;
          state.user.isMuted = user.isMuted;
        }
        dispatch('getUserInfo', user.userId);
      });
      commit('updateStatus', {
        status: updateStatus,
        ownerIsPresent: ownerIsPresent
      });
      if (!state.owner && state.status.ownerUserId !== 'unavailable') {
        dispatch('getUserInfo', state.status.ownerUserId).then(function (owner) {
          state.owner = owner;
          if (state.owner.userId !== rootState.user.currentUser.userId) {
            commit('updateRecentConferences');
          }
        });
      }
      state.user.isOwner = state.status.ownerUserId === state.status.connectedUserId;
      if (state.initializing) {
        state.initializing = false;
        state.playSounds.play('call_successfully_connected_sound').then(function () {
          if (updateStatus.participants.length === 1) {
            state.playSounds.play('call_successfully_connected_voice_paid').then(function () {
              state.playSounds.play('call_welcome').then(function () {
                if (state.user.isOwner) {
                  state.playSounds.play('call_welcome_no_participants_admin').then(function () {
                    state.playSounds.play('waiting_for_participants', true);
                  });
                } else {
                  state.playSounds.play('call_welcome_no_participants').then(function () {
                    state.playSounds.play('waiting_for_participants', true);
                  });
                }
              });
            });
          }
        });
      }
    }
    if (updateCredentials) {
      commit('updateCredentials', updateCredentials);
    }
  },
  connectCallChannelSocket: function connectCallChannelSocket(_ref30) {
    var state = _ref30.state,
        commit = _ref30.commit,
        dispatch = _ref30.dispatch,
        rootState = _ref30.rootState;

    var socketParams = {
      decode: function decode(payload, callback) {
        state.conferenceBuilder.decodePhoenix(payload, callback);
      },
      params: {
        authorization: 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$cookie.get('accessToken')
      }
    };

    state.callChannelSocket = new __WEBPACK_IMPORTED_MODULE_10_phoenix__["Socket"](__WEBPACK_IMPORTED_MODULE_9__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].WS_PATH + '/conference/call_channel', socketParams);
    state.callChannelSocket.onConnMessage = function (response) {
      state.conferenceBuilder.decodeCallChannel(response.data, function (message) {
        state.participantsCount = message.count;
      });
    };
    if (true) {
      state.callChannelSocket.connect();
    }
    if (rootState.user.currentUser) {
      var channel = state.callChannelSocket.channel('participants_count:' + rootState.user.currentUser.userId, {});
      channel.join().receive('ok', function (_ref31) {
        var messages = _ref31.messages;
        return console.log('catching up', messages);
      }).receive('error', function (_ref32) {
        var reason = _ref32.reason;
        return console.log('failed join', reason);
      }).receive('timeout', function () {
        return console.log('Networking issue. Still waiting...');
      });
      channel.on('participants_count', function (message) {
        console.info('on participants_count', message);
      });
      channel.on('participantsCount', function (message) {
        console.info('on participantsCount', message);
      });
    }
  },
  disconnectCallChannelSocket: function disconnectCallChannelSocket(_ref33) {
    var state = _ref33.state;

    state.callChannelSocket.disconnect();
    state.callChannelSocket = null;
    state.participantsCount = 0;
  },
  handleCreateSlotError: function handleCreateSlotError(_ref34, err) {
    var state = _ref34.state;

    var message = state.conferenceBuilder.decodeCreateSlotError(err.data);
    __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push('/');
    var reason = void 0;
    switch (message.code) {
      case 1:
        reason = 'incorrect_credentials';
        break;
      case 2:
        reason = 'room_locked';
        state.playSounds.play('call_locked');
        break;
      case 3:
        reason = 'room_full';
        state.playSounds.play('call_full');
        break;
      default:
        reason = 'unknown';
        break;
    }
    var id = 'prompt_join_error_' + reason;
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$modal.show('confirmation-modal', {
      id: id,
      title: __WEBPACK_IMPORTED_MODULE_8__constants_modals_constant__["a" /* modals */][id].title,
      description: __WEBPACK_IMPORTED_MODULE_8__constants_modals_constant__["a" /* modals */][id].description,
      rememberOption: false,
      actions: [{
        label: 'ok, got it',
        class: 'submit-btn'
      }]
    });
  },
  broadcast: function broadcast(_ref35, rstp) {
    var state = _ref35.state,
        commit = _ref35.commit,
        dispatch = _ref35.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit('setBroadcast', {
        url: rstp,
        pin: 123,
        startedAt: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000)
      });
      resolve(state.broadcast);
    });
  }
};

var mutations = {
  updateRecentConferences: function updateRecentConferences(state) {
    state.recentConferences = JSON.parse(localStorage.getItem('recent-conferences-' + state.user.userId)) || [];
    var index = void 0;
    state.recentConferences.forEach(function (v, i) {
      if (v.ownerId === state.owner.userId) {
        index = i;
      }
    });

    if (index >= 0) {
      if (state.recentConferences <= 0) {
        var k = 0 - state.recentConferences;
        while (k-- + 1) {
          state.recentConferences.push(undefined);
        }
      }
      state.recentConferences.splice(0, 0, state.recentConferences.splice(index, 1)[0]);
    } else {
      state.recentConferences.unshift({
        ownerId: state.owner.userId,
        avatarUrl: state.owner.avatarUrl,
        conferencePin: state.credentials.conferencePin,
        username: state.owner.username
      });
    }

    if (state.recentConferences.length > 8) {
      state.recentConferences.splice(-1, 1);
    }
    localStorage.setItem('recent-conferences-' + state.user.userId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.recentConferences));
  },
  clearConferenceState: function clearConferenceState(state) {
    state.slot = null;
    state.status = null;
    state.credentials = null;
    state.peerConnection = null;
    state.owner = null;
    state.user = null;
    state.initializing = true;
    state.startedAt = null;
    state.aside = null;
    state.ownerIsPresent = null;
    state.sequence = 1;
    state.messagesSent = [];
  },
  updateStatus: function updateStatus(state, _ref36) {
    var status = _ref36.status,
        ownerIsPresent = _ref36.ownerIsPresent;

    state.status = status;
    state.ownerIsPresent = ownerIsPresent;
    if (state.status.participants.length !== state.currentRoomParticipantsCount) {
      if (state.status.participants.length > 1 && state.status.participants.length > state.currentRoomParticipantsCount) {
        state.playSounds.play('call_participant_joined');
      }

      if (state.status.participants.length >= 1 && state.status.participants.length < state.currentRoomParticipantsCount) {
        state.playSounds.play('call_participant_left');
      }
      state.currentRoomParticipantsCount = state.status.participants.length;
    }
  },
  updateCredentials: function updateCredentials(state, credentials) {
    state.credentials = credentials;
  },
  getDevices: function getDevices(state) {
    navigator.mediaDevices.enumerateDevices().then(function (devices) {
      state.devices = devices.filter(function (d) {
        return d.kind === 'audioinput' || d.kind === 'audiooutput';
      });
    }).catch(function (e) {
      console.warn('Can\'t get devices list', e);
    });
  },
  keepSequence: function keepSequence(state, messageBody) {
    state.sequence++;
    state.messagesSent.push(messageBody);
  },
  setBroadcast: function setBroadcast(state, value) {
    state.broadcast = value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user_builder_service__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_remote_paths_constant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_modals_constant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(20);









var state = {
  currentUser: null,
  userBuilder: new __WEBPACK_IMPORTED_MODULE_3__services_user_builder_service__["a" /* default */](),
  history: [],
  historyNextToken: null,
  usersInfo: {},
  usersInfoQueue: {},
  contacts: [],
  subscription: null,
  currentUserInfo: null
};

var getters = {
  subscription: function subscription(state) {
    return state.subscription || {};
  },
  contacts: function contacts(state) {
    return state.contacts;
  },
  currentUser: function currentUser(state) {
    return state.currentUser || {};
  },
  usersInfo: function usersInfo(state) {
    return state.usersInfo;
  },
  currentUsersInfo: function currentUsersInfo(state) {
    return state.currentUserInfo || {};
  },
  currentUsersAvatarUrl: function currentUsersAvatarUrl(state) {
    return state.currentUserInfo ? state.currentUserInfo.avatarUrl : null;
  },
  userHistory: function userHistory(state) {
    var groups = {};
    var key = 'group';
    state.history.forEach(function (v) {
      v.group = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].moment(v.startTimeInMillis).format('MMMM');
      var durationMillis = v.endTimeInMillis - v.startTimeInMillis;
      if (durationMillis >= 3600000) {
        v.duration = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].moment(durationMillis).format('hh[hrs] mm[min ]ss[sec]');
      } else if (durationMillis >= 60000) {
        v.duration = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].moment(durationMillis).format('mm[min ]ss[sec]');
      } else {
        v.duration = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].moment(durationMillis).format('ss[sec]');
      }
      var cell = v[key];
      if (!groups.hasOwnProperty(cell)) {
        groups[cell] = [];
      }
      groups[cell].push(v);
    });
    return {
      groups: groups,
      length: state.history.length
    };
  }
};

var actions = {
  checkSubscription: function checkSubscription(_ref) {
    var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].checkUserSubscription().then(function (response) {
      var decoded = state.userBuilder.decodeBuyResponse(response.body);
      state.subscription = decoded.subscription;
      state.subscription.expireTimeMillis = new Date(decoded.subscription.expireTimeMillis);
    });
  },
  setConferenceUrl: function setConferenceUrl(_ref2, username) {
    var state = _ref2.state,
        commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    var body = state.userBuilder.createPutUsernameRequestBody(username);
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].setUsername(body).then(function (response) {
      var decoded = state.userBuilder.decodePutUsernameResponse(response);
      state.currentUser = decoded.currentUser;
      localStorage.setItem('currentUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(decoded.currentUser));
    });
  },
  setConferencePin: function setConferencePin(_ref3, pin) {
    var state = _ref3.state,
        commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    var body = state.userBuilder.createPutConferencePinRequestBody(pin);
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].setUserPin(body).then(function (response) {
      var decoded = state.userBuilder.decodePutConferencePinResponse(response.data);
      state.currentUser = decoded.currentUser;
      localStorage.setItem('currentUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(decoded.currentUser));
    });
  },
  getUserHistory: function getUserHistory(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var params = { items: 10 };
      if (state.historyNextToken) {
        params.next_token = state.historyNextToken;
      } else {
        state.history = [];
      }
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getHistory(params).then(function (response) {
        var decoded = state.userBuilder.decodeHistoryResponse(response.data);
        decoded.entries.forEach(function (conf) {
          conf.attendees = [];
          conf.attendeesUserIds.forEach(function (id) {
            dispatch('getUserInfo', id).then(function (user) {
              conf.attendees.push(user.name);
            });
          });
        });
        state.history = state.history.concat(decoded.entries);
        state.historyNextToken = decoded.nextToken;
        resolve(!decoded.nextToken);
      });
    });
  },
  getUserContacts: function getUserContacts(_ref5) {
    var state = _ref5.state,
        commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getContacts().then(function (response) {
        var decoded = state.userBuilder.decodeContactsResponse(response.data);
        state.contacts = [];
        decoded.contacts.forEach(function (contact) {
          dispatch('getUserInfo', contact.userId).then(function (user) {
            contact.username = user.username;
            contact.avatarUrl = user.avatarUrl;
            state.contacts.push(contact);
          });
        });
      }, function (err) {
        reject(err);
      });
    });
  },
  getUserInfo: function getUserInfo(_ref6, id) {
    var state = _ref6.state,
        commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    var userPromise = void 0;
    if (state.usersInfoQueue[id]) {
      userPromise = state.usersInfoQueue[id];
    } else {
      userPromise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!state.usersInfo[id]) {
          if (id === 'unavailable') {
            resolve();
          } else {
            state.usersInfoQueue[id] = userPromise;
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getUserInfo(id).then(function (response) {
              var decoded = state.userBuilder.decodeUserResponse(response.data);
              state.usersInfo[id] = decoded.user;
              resolve(decoded.user);
            });
          }
        } else {
          resolve(state.usersInfo[id]);
        }
      });
    }
    return userPromise;
  },
  getCurrentUser: function getCurrentUser(_ref7) {
    var state = _ref7.state,
        commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getCurrentUser().then(function (response) {
      var decodedResponse = state.userBuilder.decodeCurrentUserResponse(response.data);
      localStorage.setItem('currentUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(decodedResponse.currentUser));
      dispatch('getUserInfo', decodedResponse.currentUser.userId).then(function (user) {
        commit('setCurrentUserInfo', user);
      });
      commit('setCurrentUser', decodedResponse.currentUser);
      if (__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].history.current.name === 'MainMenu' || __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].history.current.name === 'home-tab') {
        dispatch('connectCallChannelSocket');
        __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push({
          name: 'MainMenu',
          params: { username: decodedResponse.currentUser.username }
        });
      }
    });
  },
  logout: function logout(_ref8) {
    var state = _ref8.state,
        commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$cookie.delete('accessToken', { domain: __WEBPACK_IMPORTED_MODULE_5__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].COOKIE_DOMAIN });
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$cookie.delete('refreshToken', { domain: __WEBPACK_IMPORTED_MODULE_5__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].COOKIE_DOMAIN });
    window.location.href = '' + __WEBPACK_IMPORTED_MODULE_5__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].AUTH_PATH;
  }
};

var mutations = {
  clearHistoryState: function clearHistoryState(state) {
    state.history = [];
    state.historyNextToken = null;
  },
  setCurrentUser: function setCurrentUser(state, user) {
    state.currentUser = user;
  },
  setCurrentUserInfo: function setCurrentUserInfo(state, user) {
    state.currentUserInfo = user;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_call_builder_service__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_remote_paths_constant__ = __webpack_require__(12);




var state = {
  socket: null,
  conferenceBuilder: new __WEBPACK_IMPORTED_MODULE_1__services_call_builder_service__["a" /* default */]()
};

var getters = {};

var actions = {
  connectWebsocket: function connectWebsocket(_ref, slotId) {
    var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch,
        rootState = _ref.rootState;

    if (state.socket) {
      state.socket = null;
    }
    state.socket = new WebSocket(__WEBPACK_IMPORTED_MODULE_2__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].WS_PATH + '/ws?slot_id=' + slotId);
    state.socket.onopen = function () {
      dispatch('ping');
      dispatch('setPeerConnection');
    };
    state.socket.onmessage = function (event) {
      state.conferenceBuilder.decodeConnectResponses(event.data).then(function (decodedData) {
        dispatch('receiveMessage', decodedData);
      });
    };
    state.socket.onclose = function (event) {
      if (event.code !== 1000) {
        dispatch('closeConference');
        state.socket = null;
      }
    };
  },
  ping: function ping(_ref2) {
    var state = _ref2.state,
        commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    var body = state.conferenceBuilder.createPingBody();
    setTimeout(function () {
      if (state.socket) {
        state.socket.send(body);
        dispatch('ping');
      }
    }, 10000);
  },
  receiveMessage: function receiveMessage(_ref3, response) {
    var state = _ref3.state,
        commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        rootState = _ref3.rootState;

    console.info('message', response.message);
    switch (response.message) {
      case 'updateStatus':
      case 'updateCredentials':
        dispatch('updateConference', response);
        break;
      case 'slotEnded':
        dispatch('closeConference', response.slotEnded.code);
        state.socket.close(1000, 'Deliberate disconnection');
        state.socket = null;
        break;
      case 'webrtcMessage':
        if (response.webrtcMessage.data.sessionsDescription) {
          dispatch('setRemoteDescription', response.webrtcMessage.data.sessionsDescription);
        }
        break;
      case 'adminMutedAllParticipants':
        dispatch('mutedByAdmin', response.adminMutedAllParticipants);
        break;
      default:
        break;
    }
  },
  sendSocketMessage: function sendSocketMessage(_ref4, body) {
    var state = _ref4.state;

    if (state.socket) {
      state.socket.send(body);
    }
  }
};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_safari_view_safari_view__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_safari_view_safari_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_safari_view_safari_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_confirmation_modal_confirmation_modal__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_confirmation_modal_confirmation_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_confirmation_modal_confirmation_modal__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      isSafari: false
    };
  },

  components: {
    ConfirmationModal: __WEBPACK_IMPORTED_MODULE_1__components_common_confirmation_modal_confirmation_modal___default.a,
    SafariView: __WEBPACK_IMPORTED_MODULE_0__components_common_safari_view_safari_view___default.a
  },
  mounted: function mounted() {
    this.$store.dispatch('getCurrentUser');
    this.$store.dispatch('checkBroadcastingStatus');
  },
  created: function created() {
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmationModal',
  data: function data() {
    return {
      params: {}
    };
  },

  methods: {
    beforeOpen: function beforeOpen(event) {
      this.params = event.params || {};
      if (this.params.rememberOption) {
        this.params.remember = localStorage.getItem(this.params.id);
      }
    },
    click: function click(i, event) {
      var action = this.params.actions[i];
      if (typeof action.handler === 'function') {
        action.handler(i, event);
      }
      this.$modal.hide('confirmation-modal');
    },
    remember: function remember() {
      if (this.params.remember) {
        localStorage.setItem(this.params.id, true);
      } else {
        localStorage.removeItem(this.params.id);
      }
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PageTitle',
  props: ['title'],
  created: function created() {
    document.title = this.title || 'KingsConference';
  },

  watch: {
    title: function title() {
      document.title = this.title || 'KingsConference';
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgressCircle',
  props: {
    progress: {
      required: true
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpgradeDropdown',
  props: {
    isOpen: {
      required: true
    }
  },
  computed: {
    subscription: function subscription() {
      return this.$store.getters.subscription;
    }
  },
  methods: {
    hide: function hide() {
      this.$emit('update:isOpen', false);
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'broadcasting-tab',
  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title___default.a
  },
  data: function data() {
    return {
      timeNow: 0,
      interval: null,
      startedAt: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000)
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.currentUser;
    },
    duration: function duration() {
      var duration = '00:00';
      var start = this.startedAt;
      if (start && start < this.timeNow) {
        var minutes = this.stringify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((this.timeNow - start) / 60) % 60);
        var seconds = this.stringify((this.timeNow - start) % 60);
        duration = minutes + ':' + seconds;
      }
      return duration;
    }
  },
  methods: {
    stop: function stop() {
      this.$store.dispatch('stopBroadcast');
    },
    stringify: function stringify(n) {
      if (n.toString().length <= 1) {
        n = '0' + n.toString();
      }
      return n;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.interval = setInterval(function () {
      _this.timeNow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
    }, 1000);
  },
  destroyed: function destroyed() {
    clearInterval(this.interval);
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'history-tab',
  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title___default.a
  },
  data: function data() {
    return {
      initializing: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.currentUser;
    },
    history: function history() {
      return this.$store.getters.userHistory;
    },
    userInfo: function userInfo() {
      return this.$store.getters.usersInfo;
    }
  },
  methods: {
    getHistory: function getHistory($state) {
      var _this = this;

      this.$store.dispatch('getUserHistory').then(function (endOfList) {
        _this.initializing = false;
        if ($state) {
          if (endOfList) {
            $state.complete();
          } else {
            $state.loaded();
          }
        }
      });
    }
  },
  mounted: function mounted() {
    this.initializing = true;
    this.getHistory();
  },
  destroyed: function destroyed() {
    this.$store.commit('clearHistoryState');
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_remote_paths_constant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_upgrade_dropdown_upgrade_dropdown__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_upgrade_dropdown_upgrade_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_upgrade_dropdown_upgrade_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__join_room_modal_join_room_modal__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__join_room_modal_join_room_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__join_room_modal_join_room_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__start_broadcasting_modal_start_broadcasting_modal__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__start_broadcasting_modal_start_broadcasting_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__start_broadcasting_modal_start_broadcasting_modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-tab',
  components: {
    JoinRoomModal: __WEBPACK_IMPORTED_MODULE_3__join_room_modal_join_room_modal___default.a,
    StartBroadcastingModal: __WEBPACK_IMPORTED_MODULE_4__start_broadcasting_modal_start_broadcasting_modal___default.a,
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title___default.a,
    UpgradeDropdown: __WEBPACK_IMPORTED_MODULE_2__components_common_upgrade_dropdown_upgrade_dropdown___default.a
  },
  data: function data() {
    return {
      showUpgradeMenu: false,
      copyInfoClass: null
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.currentUser;
    },
    subscription: function subscription() {
      return this.$store.getters.subscription;
    },
    participantsCount: function participantsCount() {
      return this.$store.getters.participantsCount;
    },
    showBroadcasting: function showBroadcasting() {
      if (!this.user.userId) return false;
      var showBroadcasting = true;
      var granted = __WEBPACK_IMPORTED_MODULE_0__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].IDS_WITH_ACCESS_TO_HIDDEN_FEATURES;

      if (__WEBPACK_IMPORTED_MODULE_0__constants_remote_paths_constant__["a" /* REMOTE_PATHS */].BROADCAST_HIDDEN) {
        showBroadcasting = granted ? granted.indexOf(this.user.userId) > -1 : false;
      }
      return showBroadcasting;
    }
  },
  methods: {
    joinOwnRoom: function joinOwnRoom() {
      this.$router.push({
        name: 'Room',
        params: {
          username: this.user.username,
          pin: this.user.conferencePin
        }
      });
    },
    joinRoom: function joinRoom() {
      this.$modal.show('join-room-modal');
    },
    toggleUpgradeMenu: function toggleUpgradeMenu() {
      this.showUpgradeMenu = !this.showUpgradeMenu;
    },
    setCopyInfoBtnClass: function setCopyInfoBtnClass(c, t) {
      var _this = this;

      setTimeout(function () {
        _this.copyInfoClass = c;
      }, t);
    },
    startBroadcasting: function startBroadcasting() {
      this.$modal.show('start-broadcasting-modal');
    },
    copyInfo: function copyInfo() {
      this.setCopyInfoBtnClass('processing', 0);
      var temp = document.createElement('input');
      document.querySelector('.Home__header-actions').appendChild(temp);
      temp.value = this.user.conferenceUrl;
      temp.select();
      document.execCommand('copy');
      temp.remove();
      this.setCopyInfoBtnClass('termination', 500);
      this.setCopyInfoBtnClass(null, 1000);
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'JoinRoom',
  data: function data() {
    return {
      conference: {
        id: null,
        pin: null
      }
    };
  },

  computed: {
    recentConferences: function recentConferences() {
      return this.currentUser && this.currentUser.userId ? JSON.parse(localStorage.getItem('recent-conferences-' + this.currentUser.userId)) || [] : [];
    },
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$router.push({
            name: 'Room',
            params: {
              username: _this.conference.id,
              pin: _this.conference.pin
            }
          });
        } else {
          _this.$refs.username.focus();
        }
      });
    },
    joinRecent: function joinRecent(conf) {
      this.$router.push({
        name: 'Room',
        params: {
          username: conf.username,
          pin: conf.conferencePin
        }
      });
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StartBroadcasting',
  data: function data() {
    return {
      url: null
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$store.dispatch('startBroadcast', _this.url);
        } else {
          _this.$refs.url.focus();
        }
      });
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_tab_home_tab__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_tab_home_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_tab_home_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__history_tab_history_tab__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__history_tab_history_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__history_tab_history_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings_tab_settings_tab__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings_tab_settings_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__settings_tab_settings_tab__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HomeTab: __WEBPACK_IMPORTED_MODULE_1__home_tab_home_tab___default.a,
    HistoryTab: __WEBPACK_IMPORTED_MODULE_2__history_tab_history_tab___default.a,
    SettingsTab: __WEBPACK_IMPORTED_MODULE_3__settings_tab_settings_tab___default.a
  },
  data: function data() {
    return {
      showMainMenu: false,
      tabs: [{
        name: 'home-tab',
        icon: 'icon-ic_call'
      }, {
        name: 'HistoryTab',
        icon: 'icon-ic_history'
      }, {
        name: 'SettingsTab',
        icon: 'icon-ic_settings'
      }],
      currentTab: 'home-tab'
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.currentUser;
    },
    userInfo: function userInfo() {
      return this.$store.getters.currentUsersInfo;
    },
    subscription: function subscription() {
      return this.$store.getters.subscription;
    }
  },
  methods: {
    selectTab: function selectTab(name) {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({ name: name });
    },
    logout: function logout() {
      this.$store.dispatch('logout');
    },
    toggleMainMenu: function toggleMainMenu() {
      this.showMainMenu = !this.showMainMenu;
    },
    hideMainMenu: function hideMainMenu() {
      this.showMainMenu = false;
    }
  },
  created: function created() {
    this.$store.dispatch('connectCallChannelSocket');
    this.$store.dispatch('checkSubscription');
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SetPin',
  data: function data() {
    return {
      pin: null
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$store.dispatch('setConferencePin', _this.pin);
          _this.$modal.hide('set-conference-pin-modal');
        }
      });
    },
    cancel: function cancel() {
      this.$modal.hide('set-conference-pin-modal');
    },
    beforeOpen: function beforeOpen(event) {
      this.pin = event.params.pin;
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SetUrl',
  data: function data() {
    return {
      username: null
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$store.dispatch('setConferenceUrl', _this.username);
          _this.$modal.hide('set-conference-url-modal');
        }
      });
    },
    cancel: function cancel() {
      this.$modal.hide('set-conference-url-modal');
    },
    beforeOpen: function beforeOpen(event) {
      this.username = event.params.username;
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_page_title_page_title__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_page_title_page_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_page_title_page_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_upgrade_dropdown_upgrade_dropdown__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_upgrade_dropdown_upgrade_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_upgrade_dropdown_upgrade_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__set_conference_url_modal_set_conference_url_modal__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__set_conference_url_modal_set_conference_url_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__set_conference_url_modal_set_conference_url_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__set_conference_pin_modal_set_conference_pin_modal__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__set_conference_pin_modal_set_conference_pin_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__set_conference_pin_modal_set_conference_pin_modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'settings-tab',
  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_0__components_common_page_title_page_title___default.a,
    UpgradeDropdown: __WEBPACK_IMPORTED_MODULE_1__components_common_upgrade_dropdown_upgrade_dropdown___default.a,
    SetConferenceUrl: __WEBPACK_IMPORTED_MODULE_2__set_conference_url_modal_set_conference_url_modal___default.a,
    SetConferencePin: __WEBPACK_IMPORTED_MODULE_3__set_conference_pin_modal_set_conference_pin_modal___default.a
  },
  data: function data() {
    return {
      showUpgradeMenu: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.currentUser;
    },
    profileUrl: function profileUrl() {
      return window.location.origin + '/' + this.user.username;
    },
    subscription: function subscription() {
      return this.$store.getters.subscription;
    }
  },
  methods: {
    getUserInfo: function getUserInfo(id) {
      return this.$store.getters.usersInfo[id] || {};
    },
    logout: function logout() {
      this.$store.dispatch('logout');
    },
    changeUrl: function changeUrl() {
      this.$modal.show('set-conference-url-modal', { username: this.user.username });
    },
    changePin: function changePin() {
      this.$modal.show('set-conference-pin-modal', { pin: this.user.conferencePin });
    },
    toggleUpgradeMenu: function toggleUpgradeMenu() {
      this.showUpgradeMenu = !this.showUpgradeMenu;
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_progress_circle_progress_circle__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_progress_circle_progress_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_progress_circle_progress_circle__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chat',
  components: {
    ProgressCircle: __WEBPACK_IMPORTED_MODULE_0__components_common_progress_circle_progress_circle___default.a
  },
  data: function data() {
    return {
      message: null,
      busy: null,
      file: null,
      percentComplete: null
    };
  },

  computed: {
    messages: function messages() {
      return this.$store.getters.messages;
    }
  },
  methods: {
    getUserInfo: function getUserInfo(id) {
      return this.$store.getters.usersInfo[id] || {};
    },
    submit: function submit() {
      if (this.message) {
        this.$store.dispatch('sendChatMessage', { type: 'text', data: this.message });
        this.message = null;
      }
    },
    getMessages: function getMessages($state) {
      this.$store.dispatch('getChatMessages').then(function (endOfList) {
        if ($state) {
          if (endOfList) {
            $state.complete();
          } else {
            $state.loaded();
          }
        }
      });
    },
    handUp: function handUp() {
      this.$store.dispatch('sendChatMessage', { type: 'ping' });
    },
    uploadProgress: function uploadProgress(e) {
      if (e.lengthComputable) {
        this.percentComplete = Math.round(e.loaded * 100 / e.total);
      } else {
        this.percentComplete = null;
      }
    },
    onFileChange: function onFileChange(e) {
      var _this = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.file = files[0];
      this.$store.dispatch('sendChatImage', {
        file: this.file,
        onprogress: this.uploadProgress
      }).then(function () {
        setTimeout(function () {
          _this.percentComplete = null;
          _this.file = null;
          e.target.value = null;
        }, 500);
      });
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InviteMenu',
  data: function data() {
    return {
      checked: []
    };
  },

  computed: {
    contacts: function contacts() {
      return this.$store.getters.contacts;
    }
  },
  methods: {
    check: function check(user) {
      if (this.checked.indexOf(user.userId) >= 0) {
        this.checked.splice(this.checked.indexOf(user.userId), 1);
      } else {
        this.checked.push(user.userId);
      }
    },
    submit: function submit() {
      var credentials = this.$store.getters.conference.credentials;
      this.$store.dispatch('sendInviteMessages', {
        users: this.checked,
        url: credentials.conferenceUrl,
        username: credentials.username,
        pin: credentials.conferencePin
      });
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('getUserContacts');
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotificationModal',
  data: function data() {
    return {
      text: null,
      timeout: null
    };
  },

  methods: {
    action: function action() {
      console.log('action');
      this.close();
    },
    close: function close() {
      this.$modal.hide('notification-modal');
    },
    beforeOpen: function beforeOpen(event) {
      this.text = event.params.text;
    },
    opened: function opened() {
      var _this = this;

      this.timeout = setTimeout(function () {
        _this.close();
      }, 3000);
    },
    beforeClose: function beforeClose() {
      clearTimeout(this.timeout);
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParticipantMoreMenu',
  props: {
    user: {
      required: true
    },
    name: {}
  },
  data: function data() {
    return {
      isOpen: false,
      actions: {},
      style: {}
    };
  },

  methods: {
    openMoreMenu: function openMoreMenu() {
      this.isOpen = true;
      this.setActions();
      this.setPosition();
    },
    setPosition: function setPosition() {
      var menu_width = 210;
      var position = this.$el.getBoundingClientRect();
      var top = position.top + 5 + 'px';
      var left = position.left + 'px';
      var vw = window.innerWidth;
      if (vw - menu_width <= position.right) {
        left = position.left + position.width - menu_width + 'px';
      }
      this.style = { top: top, left: left };
    },
    hideMoreMenu: function hideMoreMenu() {
      this.isOpen = false;
    },
    setActions: function setActions() {
      var _this = this;

      this.actions = {
        mute: {
          label: (this.user.isMuted ? 'Unm' : 'M') + 'ute ' + this.name,
          handler: function handler() {
            if (_this.user.isMuted) {
              _this.$store.dispatch('unmuteUser', _this.user.userId);
            } else {
              _this.$store.dispatch('muteUser', _this.user.userId);
            }
            _this.isOpen = false;
          }
        },
        admin: {
          label: (this.user.isAdmin ? 'Remove' : 'Give') + ' ' + this.name + ' Admin Rights',
          handler: function handler() {
            _this.$store.dispatch('putAdminRights', {
              userId: _this.user.userId,
              isAdmin: !_this.user.isAdmin
            });
            _this.isOpen = false;
          }
        },
        kick: {
          label: 'Remove ' + this.name + ' from Call',
          handler: function handler() {
            _this.$store.dispatch('kickUser', _this.user.userId);
            _this.isOpen = false;
          }
        }
      };
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RoomActions',
  props: {
    user: {
      required: true
    },
    conference: {
      required: true
    }
  },
  computed: {
    asideType: function asideType() {
      return this.$store.getters.aside;
    },
    unreadMessagesCount: function unreadMessagesCount() {
      return this.$store.getters.unreadMessagesCount;
    }
  },
  methods: {
    setTitle: function setTitle() {
      this.$modal.show('set-title-modal', {
        title: this.conference.status.title
      });
    },
    toggleAside: function toggleAside(type) {
      this.$store.dispatch('toggleAside', type);
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_modal_settings_modal__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_modal_settings_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__settings_modal_settings_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__set_title_modal_set_title_modal__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__set_title_modal_set_title_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__set_title_modal_set_title_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notification_modal_notification_modal__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notification_modal_notification_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__notification_modal_notification_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__participant_more_menu_participant_more_menu__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__participant_more_menu_participant_more_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__participant_more_menu_participant_more_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__room_actions_room_actions__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__room_actions_room_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__room_actions_room_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__invite_menu_invite_menu__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__invite_menu_invite_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__invite_menu_invite_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chat_chat__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chat_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__chat_chat__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SettingsModal: __WEBPACK_IMPORTED_MODULE_2__settings_modal_settings_modal___default.a,
    SetTitleModal: __WEBPACK_IMPORTED_MODULE_3__set_title_modal_set_title_modal___default.a,
    NotificationModal: __WEBPACK_IMPORTED_MODULE_4__notification_modal_notification_modal___default.a,
    ParticipantMoreMenu: __WEBPACK_IMPORTED_MODULE_5__participant_more_menu_participant_more_menu___default.a,
    RoomActions: __WEBPACK_IMPORTED_MODULE_6__room_actions_room_actions___default.a,
    InviteMenu: __WEBPACK_IMPORTED_MODULE_7__invite_menu_invite_menu___default.a,
    Chat: __WEBPACK_IMPORTED_MODULE_8__chat_chat___default.a,
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_common_page_title_page_title___default.a
  },
  data: function data() {
    return {
      now: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000),
      moreMenu: false,
      endCallInProcess: false,
      pageTitle: null
    };
  },

  computed: {
    localStreamSrc: function localStreamSrc() {
      var audio = document.getElementById('localStream');
      if (audio != null && this.$store.getters.localStreamSrc != null) {
        audio.srcObject = this.$store.getters.localStreamSrc;
        audio.muted = true;
      }
      return this.$store.getters.localStreamSrc;
    },
    remoteStreamSrc: function remoteStreamSrc() {
      var audio = document.getElementById('remoteStream');
      if (audio != null && this.$store.getters.remoteStreamSrc != null) {
        audio.srcObject = this.$store.getters.remoteStreamSrc;
      }
      return this.$store.getters.remoteStreamSrc;
    },
    ownerIsPresent: function ownerIsPresent() {
      return this.$store.getters.ownerIsPresent;
    },
    aside: function aside() {
      return this.$store.getters.aside;
    },
    conference: function conference() {
      return this.$store.getters.conference;
    },
    initializing: function initializing() {
      return this.$store.getters.initializing;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    owner: function owner() {
      return this.$store.getters.owner;
    },
    participants: function participants() {
      return this.conference.status ? this.conference.status.participants : [];
    },
    title: function title() {
      var title = void 0;
      if (this.conference.status && this.conference.status.title) {
        title = this.conference.status.title + ' (' + this.participants.length + ')';
        this.pageTitle = 'KingsConference - ' + this.conference.status.title;
      } else {
        title = (this.participants.length || '1') + ' Participants';
        this.pageTitle = 'KingsConference - ' + title;
      }
      return title;
    },
    talking: function talking() {
      var _this = this;

      var filtered = this.filterBy(this.participants, true, 'isTalking');
      var names = filtered.map(function (participant) {
        return _this.getUserInfo(participant.userId).name;
      });
      return names.join(', ');
    },
    duration: function duration() {
      var duration = '00:00';
      var start = this.$store.getters.startedAt;
      if (start && start < this.now) {
        var minutes = this.stringify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((this.now - start) / 60) % 60);
        var seconds = this.stringify((this.now - start) % 60);
        duration = minutes + ':' + seconds;
      }
      return duration;
    },
    muteDisable: function muteDisable() {
      return this.conference.status.listeningMode && !this.user.isOwner;
    }
  },
  methods: {
    getUserInfo: function getUserInfo(id) {
      return this.$store.getters.usersInfo[id] || {};
    },
    stringify: function stringify(n) {
      if (n.toString().length <= 1) {
        n = '0' + n.toString();
      }
      return n;
    },
    getParticipantAvatar: function getParticipantAvatar(participant) {
      return 'https://connect-kc.appunite.com/api/media/' + participant.userId;
    },
    mute: function mute() {
      if (!this.muteDisable) this.$store.dispatch('muteCall');
    },
    muteAll: function muteAll() {
      this.$store.dispatch('muteAll');
    },
    lock: function lock() {
      this.$store.dispatch('lockCall');
    },
    end: function end() {
      this.endCallInProcess = true;
      this.$store.dispatch('endCall');
    },
    openSettings: function openSettings() {
      this.$modal.show('settings-modal');
    },
    openMoreMenu: function openMoreMenu(participant) {
      this.moreMenu = participant.userId;
    },
    hideMoreMenu: function hideMoreMenu() {
      this.moreMenu = false;
    }
  },
  created: function created() {
    var _this2 = this;

    this.interval = setInterval(function () {
      _this2.now = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
    }, 1000);
    var params = {
      username: this.$route.params.username,
      pin: this.$route.params.pin
    };
    this.$store.dispatch('joinRoom', params).then(function () {
      _this2.start = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
    });
  },
  destroyed: function destroyed() {
    clearInterval(this.interval);
    this.$store.dispatch('disconnectChat');
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SetTitle',
  data: function data() {
    return {
      title: null
    };
  },

  methods: {
    submit: function submit(e) {
      var _this = this;

      e.preventDefault();
      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$store.dispatch('setConferenceTitle', _this.title);
          _this.$modal.hide('set-title-modal');
        }
      });
    },
    cancel: function cancel() {
      this.$modal.hide('set-title-modal');
    },
    beforeOpen: function beforeOpen(event) {
      this.title = event.params.title;
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  data: function data() {
    return {
      volume: null,
      interval: null,
      audioContext: null
    };
  },

  computed: {
    devices: function devices() {
      return this.$store.getters.devices;
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          localStorage.setItem('default-audio-input', _this.devices.selectedInput.deviceId);
          localStorage.setItem('default-audio-output', _this.devices.selectedOutput.deviceId);
        }
        _this.$modal.hide('settings-modal');
      });
    },
    cancel: function cancel() {
      this.$store.dispatch('setDefaultDevices');
      this.$modal.hide('settings-modal');
    },
    inputChanged: function inputChanged(v) {
      var _this2 = this;

      if (v && this.devices.selectedInput.deviceId !== v.deviceId) {
        this.$store.dispatch('startStream', v.deviceId).then(function (stream) {
          _this2.initIndicator();
        });
        this.devices.selectedInput = v;
      } else {
        this.devices.selectedInput = this.devices.input[0];
      }
    },
    outputChanged: function outputChanged(v) {
      if (this.devices.selectedOutput.deviceId !== v.deviceId) {
        this.$store.dispatch('attachSinkId', v.deviceId);
        this.devices.selectedOutput = v;
      }
    },
    initIndicator: function initIndicator() {
      var _this3 = this;

      if (this.interval) {
        clearInterval(this.interval);
      }
      var analyser = this.audioContext.createAnalyser();
      var microphone = this.audioContext.createMediaStreamSource(this.$store.getters.localStream);

      analyser.minDecibels = -130;
      analyser.maxDecibels = -30;
      analyser.smoothingTimeConstant = 0.7;
      analyser.fftSize = 256;

      microphone.connect(analyser);

      this.interval = setInterval(function () {
        var array = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(array);
        var values = 0;
        var length = array.length;
        for (var i = 0; i < length; i++) {
          values += array[i];
        }

        _this3.volume = values / length / 25.6;
      }, 15);
    },
    beforeOpen: function beforeOpen() {
      this.$store.commit('getDevices');
      this.initIndicator();
    },
    beforeClose: function beforeClose() {
      clearInterval(this.interval);
    }
  },
  created: function created() {
    this.audioContext = window.AudioContext || window.webkitAudioContext;
  }
});

/***/ }),
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */,
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 80,
	"./af.js": 80,
	"./ar": 87,
	"./ar-dz": 81,
	"./ar-dz.js": 81,
	"./ar-kw": 82,
	"./ar-kw.js": 82,
	"./ar-ly": 83,
	"./ar-ly.js": 83,
	"./ar-ma": 84,
	"./ar-ma.js": 84,
	"./ar-sa": 85,
	"./ar-sa.js": 85,
	"./ar-tn": 86,
	"./ar-tn.js": 86,
	"./ar.js": 87,
	"./az": 88,
	"./az.js": 88,
	"./be": 89,
	"./be.js": 89,
	"./bg": 90,
	"./bg.js": 90,
	"./bm": 91,
	"./bm.js": 91,
	"./bn": 93,
	"./bn-bd": 92,
	"./bn-bd.js": 92,
	"./bn.js": 93,
	"./bo": 94,
	"./bo.js": 94,
	"./br": 95,
	"./br.js": 95,
	"./bs": 96,
	"./bs.js": 96,
	"./ca": 97,
	"./ca.js": 97,
	"./cs": 98,
	"./cs.js": 98,
	"./cv": 99,
	"./cv.js": 99,
	"./cy": 100,
	"./cy.js": 100,
	"./da": 101,
	"./da.js": 101,
	"./de": 104,
	"./de-at": 102,
	"./de-at.js": 102,
	"./de-ch": 103,
	"./de-ch.js": 103,
	"./de.js": 104,
	"./dv": 105,
	"./dv.js": 105,
	"./el": 106,
	"./el.js": 106,
	"./en-au": 107,
	"./en-au.js": 107,
	"./en-ca": 108,
	"./en-ca.js": 108,
	"./en-gb": 109,
	"./en-gb.js": 109,
	"./en-ie": 110,
	"./en-ie.js": 110,
	"./en-il": 111,
	"./en-il.js": 111,
	"./en-in": 112,
	"./en-in.js": 112,
	"./en-nz": 113,
	"./en-nz.js": 113,
	"./en-sg": 114,
	"./en-sg.js": 114,
	"./eo": 115,
	"./eo.js": 115,
	"./es": 119,
	"./es-do": 116,
	"./es-do.js": 116,
	"./es-mx": 117,
	"./es-mx.js": 117,
	"./es-us": 118,
	"./es-us.js": 118,
	"./es.js": 119,
	"./et": 120,
	"./et.js": 120,
	"./eu": 121,
	"./eu.js": 121,
	"./fa": 122,
	"./fa.js": 122,
	"./fi": 123,
	"./fi.js": 123,
	"./fil": 124,
	"./fil.js": 124,
	"./fo": 125,
	"./fo.js": 125,
	"./fr": 128,
	"./fr-ca": 126,
	"./fr-ca.js": 126,
	"./fr-ch": 127,
	"./fr-ch.js": 127,
	"./fr.js": 128,
	"./fy": 129,
	"./fy.js": 129,
	"./ga": 130,
	"./ga.js": 130,
	"./gd": 131,
	"./gd.js": 131,
	"./gl": 132,
	"./gl.js": 132,
	"./gom-deva": 133,
	"./gom-deva.js": 133,
	"./gom-latn": 134,
	"./gom-latn.js": 134,
	"./gu": 135,
	"./gu.js": 135,
	"./he": 136,
	"./he.js": 136,
	"./hi": 137,
	"./hi.js": 137,
	"./hr": 138,
	"./hr.js": 138,
	"./hu": 139,
	"./hu.js": 139,
	"./hy-am": 140,
	"./hy-am.js": 140,
	"./id": 141,
	"./id.js": 141,
	"./is": 142,
	"./is.js": 142,
	"./it": 144,
	"./it-ch": 143,
	"./it-ch.js": 143,
	"./it.js": 144,
	"./ja": 145,
	"./ja.js": 145,
	"./jv": 146,
	"./jv.js": 146,
	"./ka": 147,
	"./ka.js": 147,
	"./kk": 148,
	"./kk.js": 148,
	"./km": 149,
	"./km.js": 149,
	"./kn": 150,
	"./kn.js": 150,
	"./ko": 151,
	"./ko.js": 151,
	"./ku": 152,
	"./ku.js": 152,
	"./ky": 153,
	"./ky.js": 153,
	"./lb": 154,
	"./lb.js": 154,
	"./lo": 155,
	"./lo.js": 155,
	"./lt": 156,
	"./lt.js": 156,
	"./lv": 157,
	"./lv.js": 157,
	"./me": 158,
	"./me.js": 158,
	"./mi": 159,
	"./mi.js": 159,
	"./mk": 160,
	"./mk.js": 160,
	"./ml": 161,
	"./ml.js": 161,
	"./mn": 162,
	"./mn.js": 162,
	"./mr": 163,
	"./mr.js": 163,
	"./ms": 165,
	"./ms-my": 164,
	"./ms-my.js": 164,
	"./ms.js": 165,
	"./mt": 166,
	"./mt.js": 166,
	"./my": 167,
	"./my.js": 167,
	"./nb": 168,
	"./nb.js": 168,
	"./ne": 169,
	"./ne.js": 169,
	"./nl": 171,
	"./nl-be": 170,
	"./nl-be.js": 170,
	"./nl.js": 171,
	"./nn": 172,
	"./nn.js": 172,
	"./oc-lnc": 173,
	"./oc-lnc.js": 173,
	"./pa-in": 174,
	"./pa-in.js": 174,
	"./pl": 175,
	"./pl.js": 175,
	"./pt": 177,
	"./pt-br": 176,
	"./pt-br.js": 176,
	"./pt.js": 177,
	"./ro": 178,
	"./ro.js": 178,
	"./ru": 179,
	"./ru.js": 179,
	"./sd": 180,
	"./sd.js": 180,
	"./se": 181,
	"./se.js": 181,
	"./si": 182,
	"./si.js": 182,
	"./sk": 183,
	"./sk.js": 183,
	"./sl": 184,
	"./sl.js": 184,
	"./sq": 185,
	"./sq.js": 185,
	"./sr": 187,
	"./sr-cyrl": 186,
	"./sr-cyrl.js": 186,
	"./sr.js": 187,
	"./ss": 188,
	"./ss.js": 188,
	"./sv": 189,
	"./sv.js": 189,
	"./sw": 190,
	"./sw.js": 190,
	"./ta": 191,
	"./ta.js": 191,
	"./te": 192,
	"./te.js": 192,
	"./tet": 193,
	"./tet.js": 193,
	"./tg": 194,
	"./tg.js": 194,
	"./th": 195,
	"./th.js": 195,
	"./tk": 196,
	"./tk.js": 196,
	"./tl-ph": 197,
	"./tl-ph.js": 197,
	"./tlh": 198,
	"./tlh.js": 198,
	"./tr": 199,
	"./tr.js": 199,
	"./tzl": 200,
	"./tzl.js": 200,
	"./tzm": 202,
	"./tzm-latn": 201,
	"./tzm-latn.js": 201,
	"./tzm.js": 202,
	"./ug-cn": 203,
	"./ug-cn.js": 203,
	"./uk": 204,
	"./uk.js": 204,
	"./ur": 205,
	"./ur.js": 205,
	"./uz": 207,
	"./uz-latn": 206,
	"./uz-latn.js": 206,
	"./uz.js": 207,
	"./vi": 208,
	"./vi.js": 208,
	"./x-pseudo": 209,
	"./x-pseudo.js": 209,
	"./yo": 210,
	"./yo.js": 210,
	"./zh-cn": 211,
	"./zh-cn.js": 211,
	"./zh-hk": 212,
	"./zh-hk.js": 212,
	"./zh-mo": 213,
	"./zh-mo.js": 213,
	"./zh-tw": 214,
	"./zh-tw.js": 214
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 371;

/***/ }),
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/history_empty.f93af0d.png";

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-icon.f8ac843.png";

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_connecting.4f9a1c6.mp3";

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_ended.5b2b04a.mp3";

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_full.5cbc3d5.mp3";

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_locked.b7ee7c5.mp3";

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_mute.7a0c04f.mp3";

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_muted.865b8c8.mp3";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_participant_joined.3604f4a.mp3";

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_participant_left.a0fe592.mp3";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_successfully_connected_sound.395e861.mp3";

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_successfully_connected_voice_free.214ce09.mp3";

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_successfully_connected_voice_paid.74219c8.mp3";

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_welcome.7f7d3b4.mp3";

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_welcome_no_participants.7a59b01.mp3";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call_welcome_no_participants_admin.fd6de1c.mp3";

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/message_ping.5cab6bc.mp3";

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/message_received_sound.8b03400.mp3";

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "data:audio/mpeg;base64,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"

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/waiting_for_participants.b299c41.mp3";

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(441),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66f1ba36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(438),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3668bf47",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(435),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-217a0cea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(430),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12c0db09",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(448),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cf71330e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(429),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ba38446",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(353)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(432),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-183f6ead",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(427),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0685a2fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(442),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6fc6c7c1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(434),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c370115",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(349)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(428),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06f77fc6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(437),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3500be95",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(444),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c2a1cd1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(447),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bf4fae16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(426),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0057fee5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(433),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b49772f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(445),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a6d8ffd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Room__main-container",
    class: {
      'aside-opened': _vm.aside
    }
  }, [_c('div', {
    staticClass: "Room__header"
  }, [_c('div', {
    staticClass: "Room__header-main"
  }, [_c('div', {
    staticClass: "Room__info"
  }, [_c('div', {
    staticClass: "Room__info-item"
  }, [_c('i', {
    staticClass: "icon-ic_link Room__icon-link"
  }), _vm._v("\n          " + _vm._s(_vm.conference.credentials.conferenceUrl) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "Room__info-item"
  }, [_c('i', {
    staticClass: "icon-ic_lock Room__icon-lock"
  }), _vm._v("\n          PIN " + _vm._s(_vm.conference.credentials.conferencePin) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "Room__call-info"
  }, [_c('div', {
    staticClass: "Room__call-info-timer"
  }, [_vm._v("\n          " + _vm._s(_vm.duration) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "Room__call-info-participants"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")])]), _vm._v(" "), _c('room-actions', {
    attrs: {
      "user": _vm.user,
      "conference": _vm.conference
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Room__header-sub"
  }, [(!_vm.initializing && _vm.ownerIsPresent) ? _c('div', [_c('div', {
    staticClass: "Room__talking-participants"
  }, [_vm._v("\n          " + _vm._s(_vm.talking) + "\n        ")]), _vm._v(" "), (_vm.user.isOwner) ? _c('i', {
    staticClass: "icon-ic_mute-all Room__mute-all",
    on: {
      "click": _vm.muteAll
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.initializing && !_vm.ownerIsPresent) ? _c('div', {
    staticClass: "Room__header-missing-owner"
  }, [_vm._v("\n        Waiting for organizer (admin) to arrive…\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "Room__body"
  }, [(_vm.ownerIsPresent) ? _c('div', {
    staticClass: "Room__body-background",
    style: ({
      'background-image': 'url(' + _vm.owner.avatarUrl + ')'
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Room__body-background-overlay",
    class: {
      'missing-owner': !_vm.initializing && !_vm.ownerIsPresent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Room__body-container"
  }, [(!_vm.initializing) ? _c('div', {
    staticClass: "Room__participants",
    class: {
      'alone': _vm.participants.length === 1
    },
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.participants), function(participant, index) {
    return _c('div', {
      key: index,
      staticClass: "Room__participant",
      class: {
        admin: participant.isAdmin, muted: participant.isMuted, talking: participant.isTalking
      }
    }, [(_vm.getUserInfo(participant.userId).avatarUrl) ? _c('img', {
      staticClass: "Room__participant-avatar",
      attrs: {
        "src": _vm.getUserInfo(participant.userId).avatarUrl
      }
    }) : _c('img', {
      staticClass: "Room__participant-avatar Room__participant-avatar--default",
      attrs: {
        "src": __webpack_require__(388)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Room__participant-container"
    }, [_c('div', {
      staticClass: "Room__participant-toolbar"
    }, [_c('div', {
      staticClass: "Room__participant-info"
    }, [(participant.isAdmin) ? _c('i', {
      staticClass: "icon-ic_admin"
    }) : _vm._e(), _vm._v(" "), (participant.isMuted) ? _c('i', {
      staticClass: "icon-ic_muted"
    }) : _vm._e(), _vm._v(" "), (false) ? _c('i', {
      staticClass: "icon-ic_handup"
    }) : _vm._e()]), _vm._v(" "), (_vm.user.isAdmin & _vm.user.userId !== participant.userId) ? _c('participant-more-menu', {
      attrs: {
        "user": participant,
        "name": _vm.getUserInfo(participant.userId).name
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "Room__participant-name"
    }, [_vm._v("\n              " + _vm._s(_vm.getUserInfo(participant.userId).name) + "\n            ")])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.initializing) ? _c('i', {
    staticClass: "icon-ic_spinner Room__initializing-spinner"
  }) : _vm._e()]), _vm._v(" "), _c('audio', {
    staticClass: "hidden",
    attrs: {
      "src": _vm.localStreamSrc,
      "id": "localStream",
      "autoplay": "",
      "controls": "",
      "muted": ""
    }
  }), _vm._v(" "), _c('audio', {
    staticClass: "hidden",
    attrs: {
      "src": _vm.remoteStreamSrc,
      "id": "remoteStream",
      "autoplay": "",
      "controls": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer"
  }, [_c('transition', {
    attrs: {
      "name": "appear-from-bottom"
    }
  }, [(_vm.participants.length) ? _c('div', {
    staticClass: "Room__footer-actions"
  }, [_c('div', {
    staticClass: "Room__footer-action",
    on: {
      "click": _vm.openSettings
    }
  }, [_c('div', {
    staticClass: "Room__footer-action-btn"
  }, [_c('i', {
    staticClass: "icon-ic_settings"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action-description"
  }, [_vm._v("\n          Settings\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action",
    on: {
      "click": _vm.mute
    }
  }, [_c('div', {
    staticClass: "Room__footer-action-btn",
    class: {
      'active': _vm.user.isMuted,
        'Room__footer-action-btn--disabled': _vm.muteDisable
    }
  }, [_c('i', {
    staticClass: "icon-ic_mute"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action-description"
  }, [_vm._v("\n          " + _vm._s(_vm.user.isMuted ? 'Muted' : 'Mute') + "\n        ")])]), _vm._v(" "), (_vm.user.isOwner) ? _c('div', {
    staticClass: "Room__footer-action",
    on: {
      "click": _vm.lock
    }
  }, [_c('div', {
    staticClass: "Room__footer-action-btn",
    class: {
      'active': _vm.conference.status.locked
    }
  }, [_c('i', {
    staticClass: "icon-ic_lock-call"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action-description"
  }, [_vm._v("\n          " + _vm._s(_vm.conference.status.locked ? 'Locked' : 'Lock') + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action",
    class: {
      'invalidate': _vm.endCallInProcess
    },
    on: {
      "click": _vm.end
    }
  }, [_c('div', {
    staticClass: "Room__footer-action-btn Room__end-call-btn"
  }, [_c('i', {
    staticClass: "icon-ic_call_end Room__end-call-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action-description"
  }, [_vm._v("\n          " + _vm._s(_vm.user.isOwner ? 'End Call' : 'Leave Call') + "\n        ")])])]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c(_vm.aside, {
    tag: "div",
    staticClass: "Room__aside"
  })], 1), _vm._v(" "), _c('settings-modal'), _vm._v(" "), _c('set-title-modal'), _vm._v(" "), _c('notification-modal'), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": _vm.pageTitle
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "set-conference-pin-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": 428
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "SetConferencePin__container"
  }, [_c('div', {
    staticClass: "SetConferencePin__title"
  }, [_vm._v("\n      Change Conference PIN\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "SetConferencePin__description"
  }, [_vm._v("\n      Enter your new PIN below.\n    ")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "settings"
    }
  }, [_c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label uppercase"
  }, [_vm._v("\n          Your PIN\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pin),
      expression: "pin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:4|max:10|numeric'),
      expression: "'required|min:4|max:10|numeric'"
    }],
    staticClass: "field",
    class: {
      'is-danger': _vm.errors.has('pin')
    },
    attrs: {
      "type": "text",
      "name": "pin",
      "placeholder": "Enter PIN of Conference Call",
      "data-vv-delay": "500",
      "data-vv-as": "PIN",
      "data-vv-name": "pin",
      "required": ""
    },
    domProps: {
      "value": (_vm.pin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pin = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pin')),
      expression: "errors.has('pin')"
    }],
    staticClass: "form-help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('pin')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-actions pull-right"
  }, [_c('a', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('a', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("save")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "InviteMenu__wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "InviteMenu__container"
  }, [(!_vm.contacts.length) ? _c('div', {
    staticClass: "InviteMenu__empty-result-box"
  }, [_vm._v("\n      You have no contacts.\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.contacts), function(user) {
    return _c('div', {
      staticClass: "InviteMenu__user-row"
    }, [_c('img', {
      directives: [{
        name: "fallback-src",
        rawName: "v-fallback-src",
        value: ('../../../../static/images/default-user-avatar.jpg'),
        expression: "'../../../../static/images/default-user-avatar.jpg'"
      }],
      staticClass: "InviteMenu__user-avatar",
      attrs: {
        "src": user.avatarUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "InviteMenu__user-info"
    }, [_c('div', {
      staticClass: "InviteMenu__name"
    }, [_vm._v("\n          " + _vm._s(user.contactName) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "InviteMenu__username"
    }, [_vm._v("\n          @" + _vm._s(user.username) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "InviteMenu__user-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.checked),
        expression: "user.checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'check_user_' + user.userId
      },
      domProps: {
        "checked": Array.isArray(user.checked) ? _vm._i(user.checked, null) > -1 : (user.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = user.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(user, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(user, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(user, "checked", $$c)
          }
        }, function($event) {
          return _vm.check(user)
        }]
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-value",
      attrs: {
        "for": 'check_user_' + user.userId
      }
    }, [_c('i', {
      staticClass: "icon-ic_tick-small InviteMenu__user-checkbox-icon"
    }), _vm._v(" "), _c('i', {
      staticClass: "icon-ic_plus InviteMenu__user-checkbox-icon"
    })])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "InviteMenu__footer"
  }, [_c('div', {
    staticClass: "InviteMenu__invite-btn",
    class: {
      'invalidate': !_vm.checked.length
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n      invite\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "InviteMenu__header"
  }, [_c('i', {
    staticClass: "InviteMenu__header-icon"
  }), _vm._v("\n    Invite via URL\n  ")])
}]}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "start-broadcasting-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": 428
    }
  }, [_c('div', {
    staticClass: "StartBroadcasting__wrapper"
  }, [_c('div', {
    staticClass: "StartBroadcasting__header"
  }, [_c('i', {
    staticClass: "StartBroadcasting__broadcast-icon icon-ic_broadcast"
  })]), _vm._v(" "), _c('div', {
    staticClass: "StartBroadcasting__container"
  }, [_c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "StartBroadcasting__title"
  }, [_vm._v("\n          Enter RSTP Link\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n          RSTP LINK\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "url",
    staticClass: "field",
    class: {
      'is-danger': _vm.errors.has('url')
    },
    attrs: {
      "type": "text",
      "name": "url",
      "placeholder": "http://",
      "data-vv-delay": "500",
      "data-vv-as": "RSTP LINK",
      "required": ""
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('url')),
      expression: "errors.has('url')"
    }],
    staticClass: "form-help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('url')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-actions pull-right"
  }, [_c('a', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('start-broadcasting-modal')
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('a', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("start")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Broadcasting__wrapper"
  }, [_c('div', {
    staticClass: "Broadcasting__body"
  }, [_c('div', {
    staticClass: "Broadcasting__body-container"
  }, [_c('div', {
    staticClass: "Broadcasting__inner"
  }, [_c('i', {
    staticClass: "Broadcasting__icon icon-ic_broadcast"
  }), _vm._v(" "), _c('div', {
    staticClass: "Broadcasting__status"
  }, [_vm._v("\n          Broadcast is on\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "Broadcasting__credentials"
  }, [_c('div', {
    staticClass: "Broadcasting__credentials-item"
  }, [_c('i', {
    staticClass: "icon-ic_link Broadcasting__credentials-icon-link"
  }), _vm._v("\n            " + _vm._s(_vm.user.conferenceUrl) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "Broadcasting__credentials-item"
  }, [_c('i', {
    staticClass: "icon-ic_lock Broadcasting__credentials-icon-lock"
  }), _vm._v("\n            PIN  " + _vm._s(_vm.user.conferencePin) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Broadcasting__main-actions"
  }, [_c('a', {
    staticClass: "Broadcasting__main-action-btn Broadcasting__main-action-btn--red",
    on: {
      "click": _vm.stop
    }
  }, [_vm._v("\n          stop broadcasting\n        ")])])])]), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": 'KingsConference - Broadcast'
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Settings__body"
  }, [_c('div', {
    staticClass: "Settings__body-container"
  }, [_c('div', {
    staticClass: "Settings__title"
  }, [_vm._v("\n      Settings\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "Settings__inner-container"
  }, [_c('img', {
    directives: [{
      name: "fallback-src",
      rawName: "v-fallback-src",
      value: ('../../../../static/images/default-user-avatar.jpg'),
      expression: "'../../../../static/images/default-user-avatar.jpg'"
    }],
    staticClass: "Settings__profile",
    attrs: {
      "src": _vm.getUserInfo(_vm.user.userId).avatarUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Settings__name"
  }, [_vm._v("\n        " + _vm._s(_vm.user.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "Settings__username"
  }, [_vm._v("\n        @" + _vm._s(_vm.user.username) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "Settings__logout-btn",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n        logout\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "Settings__rows-container"
  }, [_c('div', {
    staticClass: "Settings__row"
  }, [_c('div', {
    staticClass: "Settings__row-info Settings__account-status",
    class: _vm.subscription.active ? 'pro' : 'free'
  }, [_c('i', {
    staticClass: "icon-ic_star Settings__row-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "Settings__row-info-text"
  }, [_c('span', {
    staticClass: "Settings__account-status--free"
  }, [_vm._v("FREE USER")]), _vm._v(" "), _c('span', {
    staticClass: "Settings__account-status--pro"
  }, [_vm._v("PRO USER")]), _vm._v(" "), (_vm.subscription.autoRenewing) ? _c('span', {
    staticClass: "Settings__account-status--pro"
  }, [_vm._v("\n                Next renewal date: " + _vm._s(_vm._f("moment")(_vm.subscription.expireTimeMillis, "MMMM DD, YYYY")) + "\n              ")]) : _c('span', {
    staticClass: "Settings__account-status--pro"
  }, [_vm._v("\n                Expire date: " + _vm._s(_vm._f("moment")(_vm.subscription.expireTimeMillis, "MMMM DD, YYYY")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Settings__row-action",
    on: {
      "click": _vm.toggleUpgradeMenu
    }
  }, [(!_vm.subscription.active) ? _c('span', [_vm._v("UPGRADE FOR FREE*")]) : _vm._e(), _vm._v(" "), _c('upgrade-dropdown', {
    attrs: {
      "is-open": _vm.showUpgradeMenu
    },
    on: {
      "update:isOpen": function($event) {
        _vm.showUpgradeMenu = $event
      },
      "update:is-open": function($event) {
        _vm.showUpgradeMenu = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "Settings__row"
  }, [_c('div', {
    staticClass: "Settings__row-info"
  }, [_c('i', {
    staticClass: "icon-ic_lock Settings__row-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "Settings__row-info-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.user.conferencePin))]), _vm._v(" "), _c('span', [_vm._v("PIN")])])]), _vm._v(" "), _c('div', {
    staticClass: "Settings__row-action",
    on: {
      "click": _vm.changePin
    }
  }, [_vm._v("\n            CHANGE\n          ")])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('set-conference-url'), _vm._v(" "), _c('set-conference-pin'), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": "KingsConference - Settings"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Settings__row"
  }, [_c('div', {
    staticClass: "Settings__row-info"
  }, [_c('i', {
    staticClass: "icon-ic_help Settings__row-icon"
  }), _vm._v(" "), _c('a', {
    staticClass: "Settings__row-action",
    attrs: {
      "href": "mailto:kingsconference@joinkingschat.com"
    }
  }, [_vm._v("\n              GET HELP\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Settings__footer"
  }, [_vm._v("\n    By using the KingsPay platform, you are agreeing to our\n    "), _c('a', {
    staticClass: "Settings__footer-link",
    attrs: {
      "target": "_blank",
      "href": "https://www.kingsch.at/kingsconference/privacy"
    }
  }, [_vm._v("\n      Terms of Service\n    ")]), _vm._v(",\n    "), _c('a', {
    staticClass: "Settings__footer-link",
    attrs: {
      "target": "_blank",
      "href": "https://www.kingsch.at/kingsconference/privacy"
    }
  }, [_vm._v("\n      Acceptable Use Policy & Privacy Policy\n    ")])])
}]}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MainMenu__main-container"
  }, [_c('div', {
    staticClass: "MainMenu__header"
  }, [_c('div', {
    staticClass: "MainMenu__header-main"
  }, [_c('div', {
    staticClass: "MainMenu__header-container"
  }, [_c('div', {
    staticClass: "MainMenu__header-inner-container"
  }, [_c('img', {
    staticClass: "MainMenu__logo",
    attrs: {
      "src": __webpack_require__(229)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "MainMenu__nav-container"
  }, [_c('div', {
    staticClass: "MainMenu__nav"
  }, [_c('router-link', {
    staticClass: "MainMenu__nav-item",
    class: {
      'active': _vm.$route.name === 'MainMenu' || _vm.$route.name === 'BroadcastingTab'
    },
    attrs: {
      "to": {
        name: 'home-tab'
      }
    }
  }, [_c('i', {
    staticClass: "icon-ic_call"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "MainMenu__nav-item",
    class: {
      'active': _vm.$route.name === 'HistoryTab'
    },
    attrs: {
      "to": {
        name: 'HistoryTab'
      }
    }
  }, [_c('i', {
    staticClass: "icon-ic_history"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "MainMenu__nav-item",
    class: {
      'active': _vm.$route.name === 'SettingsTab'
    },
    attrs: {
      "to": {
        name: 'SettingsTab'
      }
    }
  }, [_c('i', {
    staticClass: "icon-ic_settings"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "MainMenu__profile"
  }, [_c('div', {
    staticClass: "MainMenu__profile-name"
  }, [_vm._v("\n                " + _vm._s(_vm.user.name) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "MainMenu__profile-avatar-container",
    on: {
      "click": _vm.toggleMainMenu
    }
  }, [_c('img', {
    directives: [{
      name: "fallback-src",
      rawName: "v-fallback-src",
      value: ('../../../static/images/default-user-avatar.jpg'),
      expression: "'../../../static/images/default-user-avatar.jpg'"
    }],
    staticClass: "MainMenu__profile-avatar",
    attrs: {
      "src": _vm.userInfo.avatarUrl
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-ic_star MainMenu__profile-status-icon",
    class: {
      'pro': _vm.subscription.active
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "scale-vertically"
    }
  }, [(_vm.showMainMenu) ? _c('div', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.hideMainMenu),
      expression: "hideMainMenu"
    }],
    staticClass: "MainMenu__nav-menu"
  }, [_c('div', {
    staticClass: "MainMenu__nav-menu-action logout",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("\n                    logout\n                  ")])]) : _vm._e()])], 1)])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "MainMenu__footer"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "set-title-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": 428
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "SetTitle__container"
  }, [_c('div', {
    staticClass: "SetTitle__title"
  }, [_vm._v("\n      Add title to conference\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "SetTitle__form"
  }, [_c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label uppercase"
  }, [_vm._v("\n          title\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "field",
    class: {
      'is-danger': _vm.errors.has('title')
    },
    attrs: {
      "type": "text",
      "name": "title",
      "placeholder": "Enter title here",
      "data-vv-delay": "500",
      "data-vv-as": "TITLE",
      "data-vv-name": "title",
      "required": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-actions pull-right"
  }, [_c('a', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('a', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("save")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Chat__wrapper"
  }, [_c('div', {
    staticClass: "Chat__main-container"
  }, [_c('transition', {
    attrs: {
      "name": "appear-from-top"
    }
  }, [(!_vm.messages.length) ? _c('div', {
    staticClass: "Chat__empty-result-box"
  }, [_c('div', {
    staticClass: "Chat__empty-result-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "Chat__empty-result-text"
  }, [_vm._v("\n        No messages yet.\n        "), _c('br'), _vm._v("\n        Start chatting!\n      ")])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "appear-from-bottom"
    }
  }, [(_vm.messages.length) ? _c('div', {
    staticClass: "Chat__container"
  }, [_vm._l((_vm.messages), function(msg, index) {
    return _c('div', {
      key: index,
      staticClass: "Chat__message"
    }, [_c('div', {
      staticClass: "Chat__message-info"
    }, [_c('img', {
      staticClass: "Chat__message-author-avatar",
      attrs: {
        "src": _vm.getUserInfo(msg.creatorId).avatarUrl || '../../../../static/images/default-user-avatar.jpg'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Chat__message-author-name"
    }, [_vm._v("\n            " + _vm._s(_vm.getUserInfo(msg.creatorId).name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "Chat__message-sent-at"
    }, [_vm._v("\n            " + _vm._s(_vm._f("moment")(msg.createdAtMillis, "h:mm a")) + "\n          ")])]), _vm._v(" "), (msg.bodyType.text) ? _c('div', {
      staticClass: "Chat__message-text-container"
    }, [_vm._v("\n          " + _vm._s(msg.bodyType.text.body) + "\n        ")]) : (msg.bodyType.ping) ? _c('div', {
      staticClass: "Chat__message-ping-container"
    }, [_c('i', {
      staticClass: "icon-ic_hand-up"
    })]) : (msg.bodyType.image) ? _c('div', {
      staticClass: "Chat__message-image-container"
    }, [_c('img', {
      directives: [{
        name: "fallback-src",
        rawName: "v-fallback-src",
        value: ('../../../../static/images/default-user-avatar.jpg'),
        expression: "'../../../../static/images/default-user-avatar.jpg'"
      }],
      staticClass: "Chat__message-image",
      attrs: {
        "src": msg.bodyType.image.imageUrl
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    staticClass: "Chat__infinite-loading-container",
    attrs: {
      "spinner": "circles",
      "direction": "top",
      "on-infinite": _vm.getMessages
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })])], 2) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "Chat__footer"
  }, [_c('transition', {
    attrs: {
      "name": "appear-from-bottom",
      "mode": "out-in"
    }
  }, [(_vm.percentComplete) ? _c('progress-circle', {
    staticClass: "Chat__attach-progress",
    attrs: {
      "progress": _vm.percentComplete
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input', {
    staticClass: "Chat__attach-input",
    attrs: {
      "id": "file-upload",
      "type": "file",
      "accept": "image/*",
      "name": "fileUpload"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "Chat__message-field",
    attrs: {
      "type": "text",
      "name": "message",
      "placeholder": "Type your message here..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-ic_hand-up Chat__hand-up",
    on: {
      "click": _vm.handUp
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SafariView__main-container"
  }, [_c('div', {
    staticClass: "SafariView__header"
  }, [_c('div', {
    staticClass: "SafariView__header-main"
  }, [_c('div', {
    staticClass: "SafariView__header-container"
  }, [_c('div', {
    staticClass: "SafariView__header-inner-container"
  }, [_c('img', {
    staticClass: "SafariView__logo",
    attrs: {
      "src": __webpack_require__(229)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__body"
  }, [_c('div', {
    staticClass: "SafariView__body-container"
  }, [_c('div', {
    staticClass: "SafariView__title"
  }, [_vm._v("\n        KingsConference doesn't work on your browser\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__body-text"
  }, [_vm._v("\n        To join the video meeting\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__body-text-info"
  }, [_vm._v("\n        Install the current version of Google Chrome or Mozilla Firefox\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__action-btn SafariView__action-btn--blue"
  }, [_c('a', {
    staticClass: "SafariView__btn-link",
    attrs: {
      "href": "https://www.google.com/chrome"
    }
  }, [_vm._v("Download Chrome")])]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__action-btn SafariView__action-btn--blue"
  }, [_c('a', {
    staticClass: "SafariView__btn-link",
    attrs: {
      "href": "https://www.mozilla.org/en-US/firefox/new"
    }
  }, [_vm._v("Download Firefox")])]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__body-text-footer"
  }, [_c('p', [_vm._v(" To install and use KingsConference on a mobile device, go to")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "SafariView__link",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.newmedia.conference&hl=en"
    }
  }, [_vm._v(" Google Play\n        ")]), _vm._v(" or the\n         "), _c('a', {
    staticClass: "SafariView__link",
    attrs: {
      "href": "https://itunes.apple.com/app/kingsconference/id1215191816?mt=8"
    }
  }, [_vm._v(" iTunes Store\n        ")])])])])])])
}]}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "History__body"
  }, [_c('div', {
    staticClass: "History__body-container"
  }, [_c('div', {
    staticClass: "History__title"
  }, [_vm._v("\n      History\n    ")]), _vm._v(" "), (_vm.history.length) ? _c('div', {
    staticClass: "History__list"
  }, [_vm._l((_vm.history.groups), function(group, key) {
    return _c('div', [_c('span', {
      staticClass: "History__group-name"
    }, [_vm._v("\n          " + _vm._s(key) + "\n        ")]), _vm._v(" "), _vm._l((group), function(event) {
      return _c('div', {
        staticClass: "History__row"
      }, [_c('div', {
        staticClass: "History__row-info"
      }, [_c('div', {
        staticClass: "History__row-date"
      }, [_vm._v("\n              " + _vm._s(_vm._f("moment")(event.startTimeInMillis, "DD")) + "\n            ")]), _vm._v(" "), _c('div', {
        staticClass: "History__conference-info"
      }, [_c('div', {
        staticClass: "History__conference-title"
      }, [_vm._v("\n                " + _vm._s(event.title || 'Untitled') + "\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "History__conference-started"
      }, [_vm._v("\n                " + _vm._s(_vm._f("moment")(event.startTimeInMillis, "dddd, MMMM Do [at] h:mm a")) + "\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "History__conference-duration"
      }, [_vm._v("\n                " + _vm._s(event.duration) + "\n              ")])])]), _vm._v(" "), _c('transition-group', {
        staticClass: "History__row-attendees",
        attrs: {
          "name": "fade-in",
          "tag": "div"
        }
      }, [_c('span', {
        key: "title",
        staticClass: "History__row-attendees-title"
      }, [_vm._v("\n              " + _vm._s(event.attendeesUserIds.length) + " Attendees:\n            ")]), _vm._v(" "), _vm._l((event.attendees), function(attendant, key) {
        return _c('div', {
          key: key,
          staticClass: "History__attendant"
        }, [_vm._v("\n              " + _vm._s(attendant))])
      })], 2)], 1)
    })], 2)
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "historyLoading",
    staticClass: "History__infinite-loading-container",
    attrs: {
      "direction": "bottom",
      "spinner": "circles"
    },
    on: {
      "infinite": _vm.getHistory
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('i', {
    staticClass: "icon-ic_spinner History__loading"
  })])])], 2) : _vm._e(), _vm._v(" "), (!_vm.history.length && !_vm.initializing) ? _c('div', {
    staticClass: "History__empty-results"
  }, [_c('img', {
    staticClass: "History__empty-results-img",
    attrs: {
      "src": __webpack_require__(389)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "History__empty-results-text"
  }, [_vm._v("\n        You haven’t held any meetings.\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.initializing) ? _c('i', {
    staticClass: "icon-ic_spinner History__loading"
  }) : _vm._e()]), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": "KingsConference - History"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "notification-modal",
      "height": "84",
      "pivot-y": .8,
      "adaptive": true,
      "width": 428
    },
    on: {
      "opened": _vm.opened,
      "before-close": _vm.beforeClose,
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "NotificationModal__container"
  }, [_c('div', {
    staticClass: "NotificationModal__text"
  }, [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "NotificationModal__action",
    on: {
      "click": _vm.action
    }
  }, [_c('i', {
    staticClass: "icon-right-open"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ProgressCircle__wrapper",
    attrs: {
      "data-progress": _vm.progress
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ProgressCircle__overlay"
  }, [_vm._v("\n    " + _vm._s(_vm.progress) + "%\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ProgressCircle__circle"
  }, [_c('div', {
    staticClass: "ProgressCircle__slice full"
  }, [_c('div', {
    staticClass: "ProgressCircle__fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ProgressCircle__slice"
  }, [_c('div', {
    staticClass: "ProgressCircle__fill"
  }), _vm._v(" "), _c('div', {
    staticClass: "ProgressCircle__fill ProgressCircle__bar"
  })])])
}]}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isSafari) ? _c('safari-view') : _c('div', [_c('router-view'), _vm._v(" "), _c('confirmation-modal')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "confirmation-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": 428
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "ConfirmationModal__container"
  }, [(_vm.params.title) ? _c('div', {
    staticClass: "ConfirmationModal__title"
  }, [_vm._v("\n      " + _vm._s(_vm.params.title || '') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.params.description) ? _c('div', {
    staticClass: "ConfirmationModal__description"
  }, [_vm._v("\n      " + _vm._s(_vm.params.description || '') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.params.rememberOption) ? _c('div', {
    staticClass: "ConfirmationModal__remember-box"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.remember),
      expression: "params.remember"
    }],
    attrs: {
      "type": "checkbox",
      "id": "remember_confirmation"
    },
    domProps: {
      "checked": Array.isArray(_vm.params.remember) ? _vm._i(_vm.params.remember, null) > -1 : (_vm.params.remember)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.params.remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.params, "remember", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.params, "remember", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.params, "remember", $$c)
        }
      }, _vm.remember]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-value",
    attrs: {
      "for": "remember_confirmation"
    }
  }, [_vm._v("\n          Don't show this anymore\n          "), _c('i', {
    staticClass: "icon-ic_tick"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.params.actions) ? _c('div', {
    staticClass: "form-actions centered"
  }, _vm._l((_vm.params.actions), function(action, i) {
    return _c('a', {
      key: i,
      class: action.class,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.click(i, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(action.label) + "\n      ")])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "set-conference-url-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": 428
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "SetConferenceUrl__container"
  }, [_c('div', {
    staticClass: "SetConferenceUrl__title"
  }, [_vm._v("\n      Change Conference URL\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "SetConferenceUrl__description"
  }, [_vm._v("\n      Please complete the URL by entering the ID. kingsconference.ng/\n    ")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "settings"
    }
  }, [_c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label uppercase"
  }, [_vm._v("\n          URL\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "field",
    class: {
      'is-danger': _vm.errors.has('username')
    },
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Enter Conference URL",
      "data-vv-delay": "500",
      "data-vv-as": "URL",
      "data-vv-name": "username",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-actions pull-right"
  }, [_c('a', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('a', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("save")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "scale-vertically"
    }
  }, [(_vm.isOpen) ? _c('div', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "UpgradeDropdown__info",
    class: {
      'pro': _vm.subscription.active
    }
  }, [_c('div', {
    staticClass: "UpgradeDropdown__info-header"
  }, [_c('i', {
    staticClass: "icon-ic_star UpgradeDropdown__info-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "UpgradeDropdown__info-body"
  }, [(!_vm.subscription.active) ? _c('div', {
    staticClass: "UpgradeDropdown__info-message"
  }, [_c('div', {
    staticClass: "UpgradeDropdown__info-title"
  }, [_vm._v("\n          Upgrade to PRO\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "UpgradeDropdown__info-text"
  }, [_vm._v("\n          Enjoy up to 100 Participants in a meeting for just $20/month.\n          You need to download the app to upgrade to PRO.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "UpgradeDropdown__info-links"
  }, [_c('a', {
    staticClass: "UpgradeDropdown__info-link",
    attrs: {
      "target": "_blank",
      "href": "https://itunes.apple.com/app/kingsconference/id1215191816?mt=8"
    }
  }, [_vm._v("\n            go to appstore\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "UpgradeDropdown__info-link",
    attrs: {
      "target": "_blank",
      "href": "https://play.google.com/store/apps/details?id=com.newmedia.conference&hl=en"
    }
  }, [_vm._v("\n            go to playstore\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.subscription.active) ? _c('div', {
    staticClass: "UpgradeDropdown__info-pro-message"
  }, [_c('div', {
    staticClass: "UpgradeDropdown__info-title"
  }, [_vm._v("\n          You're now a PRO User\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "UpgradeDropdown__info-text"
  }, [_vm._v("\n          Congratulations! You can now have meetings with up to 100 participants.\n        ")])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ParticipantMoreMenu__wrapper"
  }, [_c('i', {
    staticClass: "ParticipantMoreMenu__icon icon-ic_more",
    on: {
      "click": _vm.openMoreMenu
    }
  }), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    staticClass: "ParticipantMoreMenu__container"
  }, [_c('div', {
    directives: [{
      name: "prevent-parent-scroll",
      rawName: "v-prevent-parent-scroll"
    }],
    staticClass: "ParticipantMoreMenu__overlay",
    on: {
      "click": _vm.hideMoreMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ParticipantMoreMenu__dropdown",
    style: (_vm.style)
  }, _vm._l((_vm.actions), function(action) {
    return (!action.disabled) ? _c('div', {
      staticClass: "ParticipantMoreMenu__action",
      on: {
        "click": action.handler
      }
    }, [_vm._v("\n        " + _vm._s(action.label) + "\n      ")]) : _vm._e()
  }), 0)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "settings-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": 428,
      "clickToClose": false
    },
    on: {
      "before-open": _vm.beforeOpen,
      "before-close": _vm.beforeClose
    }
  }, [_c('div', {
    staticClass: "Settings__container"
  }, [_c('div', {
    staticClass: "Settings__title"
  }, [_vm._v("\n      Settings\n    ")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "settings"
    }
  }, [_c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n          Microphone\n        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "field-singleselect",
    attrs: {
      "on-change": _vm.inputChanged,
      "options": _vm.devices.input
    },
    model: {
      value: (_vm.devices.selectedInput),
      callback: function($$v) {
        _vm.$set(_vm.devices, "selectedInput", $$v)
      },
      expression: "devices.selectedInput"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n          Audio Output\n        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "field-singleselect",
    attrs: {
      "on-change": _vm.outputChanged,
      "options": _vm.devices.output
    },
    model: {
      value: (_vm.devices.selectedOutput),
      callback: function($$v) {
        _vm.$set(_vm.devices, "selectedOutput", $$v)
      },
      expression: "devices.selectedOutput"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n          Volume Indicator\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "Settings__volume-indicator"
  }, _vm._l((10), function(cell) {
    return _c('div', {
      staticClass: "Settings__volume-indicator-cell",
      class: {
        'active': _vm.volume >= cell
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-actions pull-right"
  }, [_c('a', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('a', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("save")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Home__main-container"
  }, [_c('div', {
    staticClass: "Home__header-sub"
  }, [_c('div', {
    staticClass: "Home__header-container"
  }, [_c('div', {
    staticClass: "Home__header-inner-container"
  }, [_c('div', {
    staticClass: "Home__header-info"
  }, [_c('div', {
    staticClass: "Home__header-info-item"
  }, [_c('i', {
    staticClass: "icon-ic_link Home__header-icon-link"
  }), _vm._v("\n            " + _vm._s(_vm.user.conferenceUrl) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "Home__header-info-item"
  }, [_c('i', {
    staticClass: "icon-ic_lock Home__header-icon-lock"
  }), _vm._v("\n            PIN " + _vm._s(_vm.user.conferencePin) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "Home__header-actions"
  }, [_c('div', {
    staticClass: "Home__header-action",
    class: _vm.copyInfoClass,
    on: {
      "click": _vm.copyInfo
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.conferenceUrl),
      expression: "user.conferenceUrl"
    }],
    staticClass: "hidden",
    attrs: {
      "type": "text",
      "id": "conference_url"
    },
    domProps: {
      "value": (_vm.user.conferenceUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "conferenceUrl", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "Home__header-action--tranquil"
  }, [_vm._v("copy info")]), _vm._v(" "), _c('i', {
    staticClass: "icon-ic_spinner Home__header-action--processing"
  }), _vm._v(" "), _c('span', {
    staticClass: "Home__header-action--termination"
  }, [_vm._v("copied")])]), _vm._v(" "), _c('div', {
    staticClass: "Home__header-action",
    class: {
      'active': _vm.subscription.active
    },
    on: {
      "click": _vm.toggleUpgradeMenu
    }
  }, [_vm._v("\n            " + _vm._s(_vm.subscription.active ? 'upgraded' : 'upgrade') + "\n          ")]), _vm._v(" "), _c('upgrade-dropdown', {
    attrs: {
      "is-open": _vm.showUpgradeMenu
    },
    on: {
      "update:isOpen": function($event) {
        _vm.showUpgradeMenu = $event
      },
      "update:is-open": function($event) {
        _vm.showUpgradeMenu = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "Home__body"
  }, [_c('div', {
    staticClass: "Home__body-container"
  }, [_c('div', {
    staticClass: "Home__title"
  }, [_vm._v("\n        Welcome to Your Conference Room\n      ")]), _vm._v(" "), _c('img', {
    staticClass: "Home__logo-icon",
    attrs: {
      "src": __webpack_require__(390)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Home__main-actions"
  }, [_c('a', {
    staticClass: "Home__main-action-btn Home__main-action-btn--blue",
    on: {
      "click": _vm.joinOwnRoom
    }
  }, [_vm._v("\n          enter my conference room\n        ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [(_vm.participantsCount) ? _c('div', {
    staticClass: "Home__waiting-count"
  }, [_c('i', {
    staticClass: "icon-ic_warning"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.participantsCount) + " Participants Waiting in Your Conference Room")])]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "Home__main-action-btn Home__main-action-btn--green",
    on: {
      "click": _vm.joinRoom
    }
  }, [_vm._v("\n          join someone else's call\n        ")]), _vm._v(" "), (_vm.showBroadcasting) ? _c('a', {
    staticClass: "Home__main-action-btn Home__main-action-btn--red",
    on: {
      "click": _vm.startBroadcasting
    }
  }, [_vm._v("\n          start broadcasting\n        ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('join-room-modal'), _vm._v(" "), _c('start-broadcasting-modal'), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": 'KingsConference - ' + _vm.user.username
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "RoomActions__wrapper"
  }, [_c('div', {
    staticClass: "RoomActions__container"
  }, [(_vm.user.isOwner) ? _c('i', {
    staticClass: "icon-ic_edit RoomActions__action-btn",
    on: {
      "click": _vm.setTitle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.isOwner) ? _c('i', {
    staticClass: "icon-ic_plus-circle RoomActions__action-btn",
    class: {
      'active': _vm.asideType === 'invite-menu'
    },
    on: {
      "click": function($event) {
        return _vm.toggleAside('invite-menu')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "icon-ic_chat RoomActions__action-btn RoomActions__chat-icon",
    class: {
      'active': _vm.asideType === 'chat'
    },
    attrs: {
      "data-count": _vm.unreadMessagesCount
    },
    on: {
      "click": function($event) {
        return _vm.toggleAside('chat')
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentUser && _vm.currentUser.userId) ? _c('modal', {
    attrs: {
      "name": "join-room-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": _vm.recentConferences.length ? 817 : 428
    }
  }, [_c('div', {
    staticClass: "JoinRoom__wrapper"
  }, [_c('div', {
    staticClass: "JoinRoom__new-conf-container"
  }, [_c('div', {
    staticClass: "JoinRoom__title"
  }, [_vm._v("\n        Join Someone Else's Call\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "JoinRoom__description"
  }, [_vm._v("\n        Please enter the @username/ID and unique PIN of the conference organizer\n      ")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "joinRoom"
    }
  }, [_c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n            ID\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.conference.id),
      expression: "conference.id"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "username",
    staticClass: "field",
    class: {
      'is-danger': _vm.errors.has('id')
    },
    attrs: {
      "type": "text",
      "name": "id",
      "placeholder": "Enter ID of Conference Call",
      "data-vv-delay": "500",
      "data-vv-as": "ID",
      "required": ""
    },
    domProps: {
      "value": (_vm.conference.id)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$refs.pin.focus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.conference, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('id')),
      expression: "errors.has('id')"
    }],
    staticClass: "form-help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('id')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n            PIN\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.conference.pin),
      expression: "conference.pin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "pin",
    staticClass: "field",
    class: {
      'is-danger': _vm.errors.has('pin')
    },
    attrs: {
      "type": "text",
      "name": "pin",
      "placeholder": "Enter PIN of Conference Call",
      "data-vv-delay": "500",
      "data-vv-as": "PIN",
      "required": ""
    },
    domProps: {
      "value": (_vm.conference.pin)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.conference, "pin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pin')),
      expression: "errors.has('pin')"
    }],
    staticClass: "form-help is-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('pin')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-actions pull-right"
  }, [_c('a', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('join-room-modal')
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('a', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("join")])])])])]), _vm._v(" "), (_vm.recentConferences.length) ? _c('div', {
    staticClass: "JoinRoom__recent-conf-container"
  }, [_c('div', {
    staticClass: "JoinRoom__title"
  }, [_vm._v("\n        Or Join Recent Conference Room\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "JoinRoom__recent-conf-list"
  }, _vm._l((_vm.recentConferences), function(conf) {
    return _c('div', {
      staticClass: "JoinRoom__recent-conf-element",
      on: {
        "click": function($event) {
          return _vm.joinRecent(conf)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "fallback-src",
        rawName: "v-fallback-src",
        value: ('../../../../../static/images/default-user-avatar.jpg'),
        expression: "'../../../../../static/images/default-user-avatar.jpg'"
      }],
      staticClass: "JoinRoom__recent-conf-avatar",
      attrs: {
        "src": conf.avatarUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "JoinRoom__recent-conf-username"
    }, [_vm._v("\n            @" + _vm._s(conf.username) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "JoinRoom__recent-conf-pin"
    }, [_vm._v("\n            " + _vm._s(conf.conferencePin) + "\n          ")])])
  }), 0)]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./call_connecting.mp3": 391,
	"./call_ended.mp3": 392,
	"./call_full.mp3": 393,
	"./call_locked.mp3": 394,
	"./call_mute.mp3": 395,
	"./call_muted.mp3": 396,
	"./call_participant_joined.mp3": 397,
	"./call_participant_left.mp3": 398,
	"./call_successfully_connected_sound.mp3": 399,
	"./call_successfully_connected_voice_free.mp3": 400,
	"./call_successfully_connected_voice_paid.mp3": 401,
	"./call_welcome.mp3": 402,
	"./call_welcome_no_participants.mp3": 403,
	"./call_welcome_no_participants_admin.mp3": 404,
	"./message_ping.mp3": 405,
	"./message_received_sound.mp3": 406,
	"./message_sent_sound.mp3": 407,
	"./waiting_for_participants.mp3": 408
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;

/***/ }),
/* 454 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[259]);


// WEBPACK FOOTER //
// static/js/app.3cf43e5298965de533c5.js